// ============================================
// HYBRID CAMPAIGN DASHBOARD
// Matches brandconnect-module.vercel.app/campaigns/[id]/dashboard
// ============================================

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import mixpanel from '../../utils/mixpanel';
import {
    getPlannerCampaignById,
    getPlannerCampaignDeals,
    getPlannerCampaignVideos,
    getPlannerCampaignReport,
    updatePlannerCampaign,
    completePlannerCampaign,
    archivePlannerCampaign,
    shortlistPlannerCreator,
    linkPlannerVideo,
    unlinkPlannerVideo,
    cancelPlannerCreatorDeal,
    activatePlannerDeal,
    completePlannerDeal,
    syncPlannerVideo,
    pickBrandConnectField,
} from '../PlannerCampaign/api/plannerCampaignApi';
import EditVideoInsightsModal from './EditVideoInsightsModal';
import { FEATURE_YT_ADSTATS } from 'config';

// ---- Helpers ----
const fmtN = (n) => { const v = Number(n); if (isNaN(v) || n == null) return '0'; return v >= 1e6 ? (v / 1e6).toFixed(1) + 'M' : v >= 1e3 ? (v / 1e3).toFixed(1) + 'K' : String(v); };
const fmtC = (n) => { const v = Number(n); if (isNaN(v) || n == null) return '₹0'; return v >= 1e5 ? `₹${(v / 1e5).toFixed(1)}L` : v >= 1e3 ? `₹${(v / 1e3).toFixed(0)}K` : `₹${v}`; };
const fmtT = (s) => { const v = Number(s); if (isNaN(v) || s == null) return '0:00'; const m = Math.floor(v / 60); return `${m}:${(v % 60).toString().padStart(2, '0')}`; };
const fmtH = (h) => { const v = Number(h); if (isNaN(v) || h == null) return '0 hrs'; return v >= 1000 ? `${(v / 1000).toFixed(1)}K hrs` : `${v.toFixed(0)} hrs`; };
const safeN = (n) => (n != null && !isNaN(Number(n))) ? Number(n) : 0;
const firstN = (...values) => {
    for (const value of values) {
        if (value == null || value === '') continue;
        const n = Number(value);
        if (!Number.isNaN(n)) return n;
    }
    return null;
};

// ---- Sample Data (legacy mocks; kept for reference) ----
/* const CAMPAIGNS = {
    '1': {
        id: '1', name: 'TTK Prestige Q1 2026', objective: 'Drive awareness for new pressure cooker range',
        status: 'active', bcEnabled: true, bcCampaignCode: 'A2Z57', startDate: '2026-01-15', endDate: '2026-03-15',
        bcData: {
            totalViews: 388620, totalLikes: 19260, totalComments: 293, liveVideos: 4,
            videosLinked: 4, videosTotal: 6, organicPercent: 78, organicViews: 302500, paidViews: 86100,
            avgEngagementRate: 5.1
        }
    },
    '2': {
        id: '2', name: 'January Activation', objective: 'Bontress Pro+ Scalp Serum awareness',
        status: 'draft', bcEnabled: false, bcCampaignCode: null, startDate: '2025-12-31', endDate: '2026-02-07', bcData: null
    },
    '3': {
        id: '3', name: 'Fortune Foods Diwali', objective: 'Festive season promotion',
        status: 'completed', bcEnabled: true, bcCampaignCode: 'B3Y82', startDate: '2025-10-01', endDate: '2025-11-15',
        bcData: {
            totalViews: 1250000, totalLikes: 45000, totalComments: 1200, liveVideos: 5,
            videosLinked: 5, videosTotal: 5, organicPercent: 85, organicViews: 1062500, paidViews: 187500, avgEngagementRate: 3.7
        }
    },
}; */

/* const DEALS = {
    '1': [
        {
            id: 'd1', creatorName: 'CookWithAnjali', channelId: 'UC_anjali_cooking', expectedVideos: 2, deliveredVideos: 2,
            cost: 1500000, status: 'COMPLETED', bcConsent: 'ACTIVE', createdAt: '2026-01-10T00:00:00Z',
            partnershipTerms: '2 dedicated recipe videos featuring TTK Prestige cooker'
        },
        {
            id: 'd2', creatorName: 'TechReviewIndia', channelId: 'UC_techreview_india', expectedVideos: 2, deliveredVideos: 1,
            cost: 2000000, status: 'ACTIVE', bcConsent: 'PENDING', createdAt: '2026-01-12T00:00:00Z',
            partnershipTerms: 'Product review + 1 shorts'
        },
        {
            id: 'd3', creatorName: 'HomeDecorByRiya', channelId: 'UC_riya_homedecor', expectedVideos: 2, deliveredVideos: 1,
            cost: 1000000, status: 'ACTIVE', bcConsent: 'ACTIVE', createdAt: '2026-01-14T00:00:00Z',
            partnershipTerms: 'Kitchen decor integration video'
        },
    ],
    '3': [
        {
            id: 'd4', creatorName: 'FestiveFoods', channelId: 'UC_festivefoods', expectedVideos: 2, deliveredVideos: 2,
            cost: 1800000, status: 'COMPLETED', bcConsent: 'ACTIVE', createdAt: '2025-09-25T00:00:00Z',
            partnershipTerms: 'Diwali special series'
        },
    ],
}; */

/* const VIDEOS = {
    '1': [
        {
            id: 'v1', title: 'TTK Prestige Pressure Cooker Review 2026 - Worth It?', creatorName: 'CookWithAnjali',
            publishedAt: '2026-01-22', consentStatus: 'ACTIVE', hasProductPlacement: true,
            metrics: { views: 145200, engagedViews: 12800, likes: 8200, comments: 145, shares: 380, watchTimeHours: 1100, avgViewDurationSecs: 287, avgViewPercentage: 72, engagementRate: 0.068 },
            trafficSplit: { organic: 76, paid: 24, organicViews: 110352, paidViews: 34848, organicEngagedViews: 10200, paidEngagedViews: 2600, organicWatchTimeHours: 870, paidWatchTimeHours: 230, organicAvgDuration: 291, paidAvgDuration: 275 },
            audienceProfile: { ageGroups: [{ range: '18-24', percentage: 28 }, { range: '25-34', percentage: 38 }, { range: '35-44', percentage: 22 }, { range: '45+', percentage: 12 }], genderSplit: { male: 58, female: 42 }, topCountries: [{ country: 'India', percentage: 82 }, { country: 'US', percentage: 6 }, { country: 'UK', percentage: 4 }] }
        },
        {
            id: 'v2', title: '5 Dishes I Made with TTK Prestige this Month!', creatorName: 'HomeDecorByRiya',
            publishedAt: '2026-01-28', consentStatus: 'ACTIVE',
            metrics: { views: 98400, engagedViews: 8100, likes: 5600, comments: 87, shares: 220, watchTimeHours: 720, avgViewDurationSecs: 265, avgViewPercentage: 68, engagementRate: 0.072 },
            trafficSplit: { organic: 80, paid: 20, organicViews: 78720, paidViews: 19680, organicEngagedViews: 6600, paidEngagedViews: 1500, organicWatchTimeHours: 580, paidWatchTimeHours: 140, organicAvgDuration: 268, paidAvgDuration: 252 }
        },
        {
            id: 'v3', title: 'Honest Review: Is TTK Prestige Worth the Hype?', creatorName: 'TechReviewIndia',
            publishedAt: '2026-02-01', consentStatus: 'PENDING',
            metrics: { views: 62000, engagedViews: 4800, likes: 3200, comments: 61, shares: 130, watchTimeHours: 480, avgViewDurationSecs: 245, avgViewPercentage: 61, engagementRate: 0.054 },
            trafficSplit: { organic: 74, paid: 26, organicViews: 45880, paidViews: 16120, organicEngagedViews: 3600, paidEngagedViews: 1200, organicWatchTimeHours: 360, paidWatchTimeHours: 120, organicAvgDuration: 250, paidAvgDuration: 230 }
        },
    ],
}; */

// ---- Constants ----
const STATUS_COLORS = {
    active: { bg: '#d1fae5', color: '#065f46' }, draft: { bg: '#f3f4f6', color: '#4b5563' }, completed: { bg: '#dbeafe', color: '#1d4ed8' }, archived: { bg: '#e5e7eb', color: '#4b5563' },
    ACTIVE: { bg: '#d1fae5', color: '#065f46' }, COMPLETED: { bg: '#dbeafe', color: '#1d4ed8' }, COMPLETE: { bg: '#dbeafe', color: '#1d4ed8' }, CANCELED: { bg: '#f3f4f6', color: '#6b7280' },
    shortlisted: { bg: '#d1fae5', color: '#065f46' }, SHORTLISTED: { bg: '#d1fae5', color: '#065f46' },
};
const CONSENT = { ACTIVE: { label: 'Linked', bg: '#d1fae5', color: '#065f46', icon: '✓' }, PENDING: { label: 'Pending', bg: '#fef3c7', color: '#92400e', icon: '⏳' }, DECLINED: { label: 'Declined', bg: '#fee2e2', color: '#991b1b', icon: '✗' } };

// ---------- ConfirmModal ----------
function ConfirmModal({ isOpen, title, message, onConfirm, onClose, confirmLabel = 'Confirm', danger = false, loading = false }) {
    if (!isOpen) return null;
    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3000, padding: 16 }} onClick={onClose}>
            <div style={{ background: '#fff', borderRadius: 16, width: '100%', maxWidth: 380, padding: '24px 24px 20px' }} onClick={e => e.stopPropagation()}>
                <div style={{ fontSize: 17, fontWeight: 700, color: '#111827', marginBottom: 8 }}>{title}</div>
                {message && <p style={{ fontSize: 13, color: '#6b7280', margin: '0 0 20px', lineHeight: 1.5 }}>{message}</p>}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                    <button onClick={onClose} disabled={loading} style={{ padding: '8px 18px', background: '#f9fafb', color: '#374151', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>Cancel</button>
                    <button onClick={onConfirm} disabled={loading} style={{ padding: '8px 18px', background: danger ? '#dc2626' : '#16a34a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>{loading ? 'Processing...' : confirmLabel}</button>
                </div>
            </div>
        </div>
    );
}

// ---------- Video Insights Modal ----------
function VideoInsightsModal({ video, onClose }) {
    if (!video) return null;

    const fmtMin = (m) => { const n = Number(m); if (!n) return '0m'; return n >= 60 ? `${Math.floor(n / 60)}h ${Math.round(n % 60)}m` : `${Math.round(n)}m`; };
    const fmtRate = (r) => (r != null && !isNaN(Number(r))) ? `${(Number(r) * 100).toFixed(2)}%` : '—';
    const fmtVal = (v) => (v != null && !isNaN(Number(v))) ? fmtN(v) : '—';
    const fmtDur = (s) => { const n = Number(s); if (!n) return '—'; return fmtT(n); };

    const org = video.organic || {};
    const paid = video.paid || {};
    const total = video.total || {};

    // ---- Split table helpers ----
    const SectionLabel = ({ children, badge }) => (
        <div style={{ fontWeight: 700, fontSize: 13, color: '#374151', textTransform: 'uppercase', letterSpacing: 0.5, display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
            {children}
            {badge && <span style={{ padding: '1px 7px', background: '#e5e7eb', color: '#4b5563', fontSize: 10, fontWeight: 700, borderRadius: 4, textTransform: 'uppercase' }}>{badge}</span>}
        </div>
    );

    const SplitTable = ({ rows }) => (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
                <tr style={{ background: '#f9fafb' }}>
                    {['Metric', 'Organic', 'Paid', 'Total'].map((h, i) => (
                        <th key={h} style={{ padding: '7px 12px', fontWeight: 700, fontSize: 11, color: '#9ca3af', textTransform: 'uppercase', textAlign: i === 0 ? 'left' : 'center', borderBottom: '1px solid #e5e7eb' }}>{h}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map(([label, o, p, t], idx) => (
                    <tr key={label} style={{ background: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                        <td style={{ padding: '7px 12px', color: '#374151', fontWeight: 500 }}>{label}</td>
                        <td style={{ padding: '7px 12px', textAlign: 'center', color: '#15803d', fontWeight: 600 }}>{o}</td>
                        <td style={{ padding: '7px 12px', textAlign: 'center', color: '#4338ca', fontWeight: 600 }}>{p}</td>
                        <td style={{ padding: '7px 12px', textAlign: 'center', color: '#111827', fontWeight: 700 }}>{t}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );

    const viewerRows = [
        ['Views', fmtVal(org.views), fmtVal(paid.views), fmtVal(total.views)],
        ['Engaged Views', fmtVal(org.engagedViews), fmtVal(paid.engagedViews), fmtVal(total.engagedViews)],
        ['Watch Time', fmtMin(org.watchTimeMinutes), fmtMin(paid.watchTimeMinutes), fmtMin(total.watchTimeMinutes)],
        ['Avg View Duration', fmtDur(org.avgViewDurationSecs), fmtDur(paid.avgViewDurationSecs), fmtDur(total.avgViewDurationSecs)],
        ['Unique Viewers', fmtVal(org.uniqueViewers), fmtVal(paid.uniqueViewers), fmtVal(total.uniqueViewers)],
    ];
    const engagementRows = [
        ['Likes', fmtVal(org.likes), fmtVal(paid.likes), fmtVal(total.likes)],
        ['Comments', fmtVal(org.comments), fmtVal(paid.comments), fmtVal(total.comments)],
        ['Shares', fmtVal(org.shares), fmtVal(paid.shares), fmtVal(total.shares)],
        ['Playlist Adds', fmtVal(org.playlistAdds), fmtVal(paid.playlistAdds), fmtVal(total.playlistAdds)],
        ['Engagement Rate', fmtRate(org.engagementRate), fmtRate(paid.engagementRate), fmtRate(total.engagementRate)],
    ];

    // ---- Age distribution ----
    const AGE_KEY_LABELS = {
        age18To24: '18–24',
        age25To34: '25–34',
        age35To44: '35–44',
        age45To54: '45–54',
        age55To64: '55–64',
        age65Plus: '65+'
        };

    const ageRows = Object.entries(AGE_KEY_LABELS).map(([key, label]) => {
        const val = video?.ageDistribution?.[key];

        return {
            label,
            views: typeof val === 'object'
            ? (val?.views ?? 0)
            : (val ?? 0)
        };
    });
    const totalAgeViews = ageRows ? ageRows.reduce((s, r) => s + (r.views || r.percentage || 0), 0) || 1 : 1;
    const maxAgeViews = ageRows ? Math.max(...ageRows.map(r => r.views || r.percentage || 0), 1) : 1;

    // ---- Gender distribution ----
    const gd = video?.genderDistribution;

    const genderEntries = [
    ['Male', typeof gd?.male === 'object' ? (gd.male?.views ?? 0) : (gd?.male ?? 0), '#2563eb', '#dbeafe'],
    ['Female', typeof gd?.female === 'object' ? (gd.female?.views ?? 0) : (gd?.female ?? 0), '#db2777', '#fce7f3'],
    ['userSpecified', typeof gd?.userSpecified === 'object' ? (gd.userSpecified?.views ?? 0) : (gd?.userSpecified ?? 0), '#7c3aed', '#ede9fe']
    ];
    const totalGender = genderEntries ? genderEntries.reduce((s, [, v]) => s + v, 0) || 1 : 1;

    // ---- Country distribution by source ----

    const cds = video.country_distribution_by_source || video.countryDistributionBySource || {};

    const organic_cds = cds.ORGANIC || cds.organic || {};
    const paid_cds = cds.PAID || cds.paid || {};
    const total_cds = cds.TOTAL || cds.total || {};
    
    const defaultCountries = ['US', 'IN', 'CA', 'MX', 'GB', 'BR', 'VN', 'DE', 'ES', 'KR'];
    
    const allCountries = [
        ...new Set([
            ...Object.keys(organic_cds),
            ...Object.keys(paid_cds),
            ...Object.keys(total_cds),
        ])
    ];
    
    const countryRows = (allCountries.length ? allCountries : defaultCountries)
        .slice(0, 10)
        .map(country => ({
            country,
            organic: organic_cds[country] ?? 0,
            paid: paid_cds[country] ?? 0,
            total: total_cds[country] ?? 0,
        }));
    
    const COUNTRY_SOURCES = [
        { key: 'organic', label: 'Organic', color: '#9ca3af' },
        { key: 'paid',    label: 'Paid',    color: '#9ca3af' },
        { key: 'total',   label: 'Total',   color: '#9ca3af' },
    ];

    // ---- State distribution by source ----
    const sds = video.state_distribution_by_source || video.stateDistributionBySource || {};
    const organic_sds = sds.ORGANIC || sds.organic || {};
    const paid_sds = sds.PAID || sds.paid || {};

    const allStates = [
        ...new Set([
            ...Object.values(organic_sds).flatMap(Object.keys),
            ...Object.values(paid_sds).flatMap(Object.keys),
        ])
    ];

    const stateRows = allStates
        .map(state => ({
            state,
            organic: Object.values(organic_sds).reduce((acc, regions) => acc + (regions[state] ?? 0), 0),
            paid: Object.values(paid_sds).reduce((acc, regions) => acc + (regions[state] ?? 0), 0),
        }))
        .sort((a, b) => b.organic - a.organic)
        .slice(0, 3);

    // const cds = video.countryDistributionBySource || {
    //     total: {},
    // };

    // const defaultCountries = ['US', 'IN', 'CA', 'MX', 'GB', 'BR', 'VN', 'DE', 'ES', 'KR'];

    // let countryRows = null;

    // if (!cds || Object.keys(cds).length === 0) {
    //     // No data → return default countries
    //     countryRows = defaultCountries.map(country => ({
    //         country,
    //         bySource: {
    //             organic: 0,
    //             paid: 0,
    //             total: 0
    //         }
    //     }));
    // } else {
    //     const sources = Object.keys(cds);

    //     const allCountries = [
    //         ...new Set(sources.flatMap(s => Object.keys(cds[s] || {})))
    //     ];

    //     countryRows = (allCountries.length ? allCountries : defaultCountries)
    //         .slice(0, 10)
    //         .map(country => ({
    //             country,
    //             bySource: sources.reduce((acc, s) => {
    //                 acc[s] = cds[s]?.[country] ?? 0;
    //                 return acc;
    //             }, {})
    //         }));
    // }

    // ---- Audience interests ----
    const renderInterests = (list) => {
        if (!list) return <span style={{ color: '#9ca3af', fontSize: 12 }}>—</span>;
        const items = Array.isArray(list) ? list : (typeof list === 'object' ? Object.keys(list) : [String(list)]);
        if (items.length === 0) return <span style={{ color: '#9ca3af', fontSize: 12 }}>No data</span>;
        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {items.map((item, i) => (
                    <span key={i} style={{ padding: '3px 10px', background: '#f3f4f6', color: '#374151', fontSize: 12, borderRadius: 20, border: '1px solid #e5e7eb' }}>
                        {typeof item === 'object' ? (item.name || item.label || JSON.stringify(item)) : item}
                    </span>
                ))}
            </div>
        );
    };

    video.organicPct = total.views > 0 ? Math.round((org.views / total.views) * 100) : 0;
    video.paidPct = total.views > 0 ? Math.round((paid.views / total.views) * 100) : 0;

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 16 }} onClick={onClose}>
            <div style={{ background: '#fff', borderRadius: 20, width: '100%', maxWidth: 860, maxHeight: '92vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
                {/* Header */}
                <div style={{ padding: '16px 24px', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, background: '#fff', zIndex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <span style={{ padding: '3px 8px', background: '#dc2626', color: '#fff', fontSize: 11, fontWeight: 700, borderRadius: 4 }}>YCP</span>
                        <div><div style={{ fontWeight: 700, fontSize: 16 }}>Video Insights</div><div style={{ fontSize: 11, color: '#9ca3af' }}>Verified YouTube Analytics</div></div>
                    </div>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 22, color: '#9ca3af', lineHeight: 1 }}>✕</button>
                </div>

                <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 22 }}>

                    {/* ── Meta Insights ── */}
                    <div style={{ background: '#f9fafb', borderRadius: 12, padding: 16, border: '1px solid #e5e7eb' }}>
                        <SectionLabel>Meta Insights</SectionLabel>
                        <div style={{ marginBottom: 8 }}>
                            <div style={{ fontWeight: 700, fontSize: 15, color: '#111827', display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                {video.youtubeVideoId ? (
                                    <a href={`https://youtube.com/watch?v=${video.youtubeVideoId}`} target="_blank" rel="noreferrer"
                                        style={{ color: '#111827', textDecoration: 'none' }}>
                                        {video.title || video.youtubeVideoId}
                                    </a>
                                ) : (video.title || '—')}
                                {video.hasProductPlacement && <span style={{ padding: '1px 6px', background: '#fef3c7', color: '#92400e', fontSize: 10, fontWeight: 700, borderRadius: 4 }}>Product Placement</span>}
                            </div>
                            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                                {video.channelId && <span>📺 {video.channelId}</span>}
                                {video.publishedAt && <span>📅 {video.publishedAt}</span>}
                                {video.durationSecs != null && video.durationSecs > 0 && <span>⏱ {fmtDur(video.durationSecs)}</span>}
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8, marginTop: 12 }}>
                            {[['👁 Views', fmtVal(video.metrics.views)], ['👍 Likes', fmtVal(video.metrics.likes)], ['💬 Comments', fmtVal(video.metrics.comments)]].map(([l, v]) => (
                                <div key={l} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '10px 12px', textAlign: 'center' }}>
                                    <div style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>{v}</div>
                                    <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>{l}</div>
                                </div>
                            ))}
                        </div>
                        {video.brandMentions && video.brandMentions.length > 0 && (
                            <div style={{ marginTop: 12 }}>
                                <div style={{ fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', marginBottom: 6 }}>Brand Mentions</div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                                    {video.brandMentions.map((m, i) => (
                                        <span key={i} style={{ padding: '2px 8px', background: '#fef3c7', color: '#92400e', fontSize: 12, borderRadius: 20 }}>{m}</span>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* ── Views & Viewer Metrics — split by ── */}
                    <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
                        <div style={{ padding: '12px 16px', background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                            <SectionLabel badge="split by source">Views &amp; Viewer Performance</SectionLabel>
                        </div>
                        <SplitTable rows={viewerRows} />
                        <div style={{ padding: '0px 10px' }}>
                            <div style={{ display: 'flex', height: 30, borderRadius: 6, overflow: 'hidden', marginBottom: 6 }}>
                                <div style={{ width: `${video.organicPct != null ? video.organicPct : 0}%`, background: '#22c55e', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 12, fontWeight: 700 }}>
                                    {video.organicPct != null && video.organicPct > 15 && `${video.organicPct}%`}
                                </div>
                                <div style={{ width: `${video.paidPct != null ? video.paidPct : 0}%`, background: '#6366f1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 12, fontWeight: 700 }}>
                                    {video.paidPct != null && video.paidPct > 15 && `${video.paidPct}%`}
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
                                <span style={{ color: '#16a34a' }}>Organic: {org.views != null ? fmtN(org.views) : '0'}</span>
                                <span style={{ color: '#4f46e5' }}>Paid: {paid.views != null ? fmtN(paid.views) : '0'}</span>
                            </div>
                        </div>
                    </div>

                    {/* ── Engagement — split by ── */}
                    <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
                        <div style={{ padding: '12px 16px', background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                            <SectionLabel badge="split by source">Engagement</SectionLabel>
                        </div>
                        <SplitTable rows={engagementRows} />
                    </div>

                    {/* ── Google Ads — Partnership Ads (separate paid source, not part of the split above) ── */}
                    {video.googleAds && (() => {
                        const ga = video.googleAds;
                        const gaViews = safeN(ga.views);
                        const gaImpressions = safeN(ga.impressions);
                        const gaClicks = safeN(ga.clicks);
                        const gaSpend = safeN(ga.spend);
                        const gaConversions = safeN(ga.conversions);
                        const cpv = gaViews > 0 ? `₹${(gaSpend / gaViews).toFixed(2)}` : '-';
                        const ctr = gaImpressions > 0 ? `${((gaClicks / gaImpressions) * 100).toFixed(2)}%` : '-';
                        const gaRows = [
                            ['Views', fmtVal(gaViews)],
                            ['Impressions', fmtVal(gaImpressions)],
                            ['Clicks', fmtVal(gaClicks)],
                            ['Spend', `₹${gaSpend.toFixed(2)}`],
                            ['Conversions', fmtVal(gaConversions)],
                            ['CPV', cpv],
                            ['CTR', ctr],
                        ];
                        return (
                            <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
                                <div style={{ padding: '12px 16px', background: '#f9fafb', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <span style={{ fontWeight: 700, fontSize: 13, color: '#374151', textTransform: 'uppercase', letterSpacing: 0.5 }}>Google Ads — Partnership Ads</span>
                                    <span style={{ padding: '1px 7px', background: '#eef2ff', color: '#4f46e5', fontSize: 10, fontWeight: 700, borderRadius: 4, textTransform: 'uppercase' }}>Paid</span>
                                </div>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                                    <tbody>
                                        {gaRows.map(([label, val], idx) => (
                                            <tr key={label} style={{ background: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                                                <td style={{ padding: '7px 12px', color: '#374151', fontWeight: 500 }}>{label}</td>
                                                <td style={{ padding: '7px 12px', textAlign: 'right', color: '#111827', fontWeight: 700 }}>{val}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div style={{ padding: '10px 16px', fontSize: 11, color: '#9ca3af', borderTop: '1px solid #f3f4f6' }}>
                                    From the brand&apos;s linked Google Ads account — separate source, not included in the split above.
                                </div>
                            </div>
                        );
                    })()}

                    {/* ── Age Distribution ── */}
                    <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
                        <div style={{ padding: '12px 16px', background: '#f9fafb', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <SectionLabel>Age Distribution</SectionLabel>
                            <span style={{ fontSize: 11, color: '#9ca3af' }}>% of viewers</span>
                        </div>
                        {ageRows && ageRows.length > 0 ? (
                            <div style={{ padding: '20px 24px 16px' }}>
                                {/* Vertical bar chart */}
                                <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, height: 120, marginBottom: 8 }}>
                                    {ageRows.map((row) => {
                                        const val = row.views ?? row.percentage ?? 0;
                                        const pct = Math.round((val / totalAgeViews) * 100);
                                        const barH = Math.round((val / maxAgeViews) * 100);
                                        const AGE_COLORS = ['#6366f1','#8b5cf6','#a78bfa','#c4b5fd','#ddd6fe','#ede9fe'];
                                        const colorIdx = ageRows.indexOf(row) % AGE_COLORS.length;
                                        return (
                                            <div key={row.label || row.range} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: '#374151' }}>{pct}%</span>
                                                <div style={{ width: '100%', height: `${barH}%`, minHeight: 4, background: AGE_COLORS[colorIdx], borderRadius: '4px 4px 0 0', transition: 'height 0.3s' }} />
                                            </div>
                                        );
                                    })}
                                </div>
                                {/* X-axis labels */}
                                <div style={{ display: 'flex', gap: 8, borderTop: '2px solid #e5e7eb', paddingTop: 6 }}>
                                    {ageRows.map((row) => (
                                        <div key={row.label || row.range} style={{ flex: 1, textAlign: 'center', fontSize: 11, color: '#6b7280', fontWeight: 500 }}>
                                            {row.label || row.range}
                                        </div>
                                    ))}
                                </div>
                                {/* Raw view counts below */}
                                <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                                    {ageRows.map((row) => {
                                        const val = row.views ?? row.percentage ?? 0;
                                        return (
                                            <div key={row.label || row.range} style={{ flex: 1, textAlign: 'center', fontSize: 10, color: '#9ca3af' }}>
                                                {fmtVal(val)}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ) : (
                            <div style={{ padding: '32px 24px', textAlign: 'center' }}>
                                <div style={{ fontSize: 28, marginBottom: 8 }}>📊</div>
                                <div style={{ fontSize: 13, color: '#9ca3af' }}>Age data not yet available for this video</div>
                            </div>
                        )}
                    </div>

                    {/* ── Gender Distribution ── */}
                    <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
                        <div style={{ padding: '12px 16px', background: '#f9fafb', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <SectionLabel>Gender Distribution</SectionLabel>
                            <span style={{ fontSize: 11, color: '#9ca3af' }}>% of viewers</span>
                        </div>
                        {genderEntries ? (
                            <div style={{ padding: '20px 24px' }}>
                                {/* Stacked horizontal bar */}
                                <div style={{ display: 'flex', height: 28, borderRadius: 8, overflow: 'hidden', marginBottom: 20 }}>
                                    {genderEntries.filter(([, v]) => v > 0).map(([label, val, color]) => {
                                        const pct = (val / totalGender) * 100;
                                        return (
                                            <div key={label} title={`${label}: ${Math.round(pct)}%`}
                                                style={{ width: `${pct}%`, background: color, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'width 0.3s' }}>
                                                {pct > 10 && <span style={{ fontSize: 11, fontWeight: 700, color: '#fff' }}>{Math.round(pct)}%</span>}
                                            </div>
                                        );
                                    })}
                                </div>
                                {/* Legend rows */}
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                    {genderEntries.map(([label, val, color]) => {
                                        const pct = Math.round((val / totalGender) * 100);
                                        return (
                                            <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                                <div style={{ width: 12, height: 12, borderRadius: 3, background: color, flexShrink: 0 }} />
                                                <span style={{ fontSize: 13, color: '#374151', fontWeight: 500, width: 60 }}>{label}</span>
                                                <div style={{ flex: 1, height: 8, background: '#f3f4f6', borderRadius: 4, overflow: 'hidden' }}>
                                                    <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: 4, transition: 'width 0.3s' }} />
                                                </div>
                                                <span style={{ fontSize: 13, fontWeight: 700, color, width: 38, textAlign: 'right' }}>{pct}%</span>
                                                <span style={{ fontSize: 11, color: '#9ca3af', width: 50, textAlign: 'right' }}>{fmtVal(val)}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ) : (
                            <div style={{ padding: '32px 24px', textAlign: 'center' }}>
                                <div style={{ fontSize: 28, marginBottom: 8 }}>👥</div>
                                <div style={{ fontSize: 13, color: '#9ca3af' }}>Gender data not yet available for this video</div>
                            </div>
                        )}
                    </div>

                    {/* ── Country Distribution by Source ── */}

                    {countryRows && countryRows.length > 0 && (
                        <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
                            <div style={{ padding: '12px 16px', background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                                <SectionLabel badge="">Country Distribution</SectionLabel>
                            </div>
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                                    <thead>
                                        <tr style={{ background: '#f9fafb' }}>
                                            <th style={{ padding: '7px 12px', fontWeight: 700, fontSize: 11, color: '#9ca3af', textTransform: 'uppercase', textAlign: 'left', borderBottom: '1px solid #e5e7eb' }}>Country</th>
                                            {COUNTRY_SOURCES.map(({ key, label }) => (
                                                <th key={key} style={{ padding: '7px 12px', fontWeight: 700, fontSize: 11, color: '#9ca3af', textTransform: 'uppercase', textAlign: 'center', borderBottom: '1px solid #e5e7eb' }}>{label}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {countryRows.map((row, idx) => (
                                            <tr key={row.country} style={{ background: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                                                <td style={{ padding: '7px 12px', fontWeight: 500, color: '#374151' }}>{row.country}</td>
                                                {COUNTRY_SOURCES.map(({ key, color }) => (
                                                    <td key={key} style={{ padding: '7px 12px', textAlign: 'center', color, fontWeight: 600 }}>
                                                        {row[key] ? fmtRate(row[key]) : '0%'}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* {countryRows && countryRows.length > 0 && (
                        <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
                            <div style={{ padding: '12px 16px', background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                                <SectionLabel badge="">Country Distribution</SectionLabel>
                            </div>
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                                    <thead>
                                        <tr style={{ background: '#f9fafb' }}>
                                            <th style={{ padding: '7px 12px', fontWeight: 700, fontSize: 11, color: '#9ca3af', textTransform: 'uppercase', textAlign: 'left', borderBottom: '1px solid #e5e7eb' }}>Country</th>
                                            {Object.keys(cds).map(src => (
                                                <th key={src} style={{ padding: '7px 12px', fontWeight: 700, fontSize: 11, color: '#9ca3af', textTransform: 'uppercase', textAlign: 'center', borderBottom: '1px solid #e5e7eb' }}>{src}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {countryRows.map((row, idx) => (
                                            <tr key={row.country} style={{ background: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                                                <td style={{ padding: '7px 12px', fontWeight: 500, color: '#374151' }}>{row.country}</td>
                                                {Object.keys(cds).map(src => (
                                                    <td key={src} style={{ padding: '7px 12px', textAlign: 'center', color: '#374151', fontWeight: 600 }}>{fmtVal(row.bySource[src])}</td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )} */}

                    {/* ── Top States ── */}
                    {stateRows && stateRows.length > 0 && (
                        <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
                            <div style={{ padding: '12px 16px', background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                                <SectionLabel badge="">Top States</SectionLabel>
                            </div>
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                                    <thead>
                                        <tr style={{ background: '#f9fafb' }}>
                                            <th style={{ padding: '7px 12px', fontWeight: 700, fontSize: 11, color: '#9ca3af', textTransform: 'uppercase', textAlign: 'left', borderBottom: '1px solid #e5e7eb' }}>State</th>
                                            <th style={{ padding: '7px 12px', fontWeight: 700, fontSize: 11, color: '#9ca3af', textTransform: 'uppercase', textAlign: 'center', borderBottom: '1px solid #e5e7eb' }}>Organic</th>
                                            <th style={{ padding: '7px 12px', fontWeight: 700, fontSize: 11, color: '#9ca3af', textTransform: 'uppercase', textAlign: 'center', borderBottom: '1px solid #e5e7eb' }}>Paid</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stateRows.map((row, idx) => (
                                            <tr key={row.state} style={{ background: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                                                <td style={{ padding: '7px 12px', fontWeight: 500, color: '#374151' }}>{row.state}</td>
                                                <td style={{ padding: '7px 12px', textAlign: 'center', color: '#9ca3af', fontWeight: 600 }}>{row.organic ? fmtRate(row.organic) : '0%'}</td>
                                                <td style={{ padding: '7px 12px', textAlign: 'center', color: '#9ca3af', fontWeight: 600 }}>{row.paid ? fmtRate(row.paid) : '0%'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* ── Audience Interests (last 28 days, not split by source) ── */}
                    {(video.shoppingInterests != null || video.watchingInterests != null) && (
                        <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
                            <div style={{ padding: '12px 16px', background: '#f9fafb', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <SectionLabel>Audience Interests</SectionLabel>
                                <span style={{ fontSize: 11, color: '#9ca3af' }}>Last 28 days</span>
                            </div>
                            <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 14 }}>
                                <div>
                                    <div style={{ fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', marginBottom: 8 }}>🛍 Shopping Interests</div>
                                    {renderInterests(video.shoppingInterests)}
                                </div>
                                <div>
                                    <div style={{ fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', marginBottom: 8 }}>📺 Watching Interests</div>
                                    {renderInterests(video.watchingInterests)}
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
}

// ---------- Deal Row ----------
function DealRow({ deal, bcEnabled, canMutateCampaign, onLinkVideo, onCancelDeal, onMarkComplete, onActivateDeal }) {
    const [expanded, setExpanded] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [cancelling, setCancelling] = useState(false);
    const [markCompleteConfirm, setMarkCompleteConfirm] = useState(false);
    const [confirmAction, setConfirmAction] = useState('complete'); // 'complete' | 'reactivate'

    const handleCancelClick = async () => {
        setMenuOpen(false);
        if (!window.confirm(`Cancel deal with ${deal.creatorName}? This action cannot be undone.`)) return;
        setCancelling(true);
        try {
            await onCancelDeal(deal);
        } finally {
            setCancelling(false);
        }
    };
    const statusKey = typeof deal.status === 'string' ? deal.status.toLowerCase() : deal.status;
    const ds = STATUS_COLORS[deal.status] || STATUS_COLORS[statusKey] || STATUS_COLORS.ACTIVE;
    const cs = CONSENT[deal.bcConsent] || { label: 'N/A', bg: '#f3f4f6', color: '#6b7280', icon: '—' };
    const progress = deal.expectedVideos > 0 ? (deal.deliveredVideos / deal.expectedVideos) * 100 : 0;
    const dealState = String(deal.dealStatus || deal.status || '')
        .replace(/^STATE_/i, '')
        .toUpperCase();
    const isDealCompleted = ['COMPLETE', 'COMPLETED'].includes(dealState);
    const isDealCanceled = ['CANCELED', 'CANCELLED'].includes(dealState);
    const isDealActive = !isDealCompleted && !isDealCanceled;
    const canMutateDeal = Boolean(canMutateCampaign) && isDealActive;
    const canReactivateDeal = Boolean(canMutateCampaign) && isDealCompleted;

    return (
        <>
        <div style={{ borderBottom: '1px solid #f3f4f6' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 24px', cursor: 'pointer', background: '#fff' }}>
                {/* Avatar + Name grouped */}
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
                    {deal.thumbnailUrl ? (
                        <img src={deal.thumbnailUrl} alt={deal.creatorName} style={{ width: 44, height: 44, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                    ) : (
                        <div style={{ width: 44, height: 44, borderRadius: '50%', background: 'linear-gradient(135deg,#fef3c7,#fde68a)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, color: '#92400e', fontSize: 17, flexShrink: 0 }}>
                            {deal.creatorName[0]}
                        </div>
                    )}
                    <div style={{ minWidth: 0 }}>
                        <div style={{ fontWeight: 600, fontSize: 14, color: '#111827' }}>{deal.creatorName}</div>
                        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 1 }}>{deal.channelId}</div>
                    </div>
                </div>
                {/* Status */}
                <div style={{ width: 90, textAlign: 'center' }}>
                    <span style={{ padding: '3px 10px', background: ds.bg, color: ds.color, fontSize: 11, fontWeight: 700, borderRadius: 20, textTransform: 'uppercase' }}>{deal.status}</span>
                </div>
                {/* Deal Status */}
                <div style={{ width: 90, textAlign: 'center' }}>
                    {isDealCompleted
                        ? <span style={{ padding: '3px 10px', background: '#dbeafe', color: '#1d4ed8', fontSize: 11, fontWeight: 700, borderRadius: 20 }}>Complete</span> :
                        isDealCanceled ? <span style={{ padding: '3px 10px', background: '#dbeafe', color: '#1d4ed8', fontSize: 11, fontWeight: 700, borderRadius: 20 }}>Cancel</span> : 
                      <span style={{ padding: '3px 10px', background: '#d1fae5', color: '#065f46', fontSize: 11, fontWeight: 700, borderRadius: 20 }}>Active</span>}
                </div>
                {/* Video Progress */}
                <div style={{ width: 90, textAlign: 'center' }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#111827', marginBottom: 4 }}>{deal.deliveredVideos}/{deal.expectedVideos}</div>
                    <div style={{ height: 5, background: '#f3f4f6', borderRadius: 3, overflow: 'hidden' }}>
                        <div style={{ width: `${progress}%`, height: '100%', background: '#22c55e', borderRadius: 3 }} />
                    </div>
                </div>
                {/* BC Consent */}
                {bcEnabled && (
                    <div style={{ width: 80, textAlign: 'center' }}>
                        <span style={{ padding: '3px 10px', background: cs.bg, color: cs.color, fontSize: 11, fontWeight: 700, borderRadius: 20 }}>{cs.icon} {cs.label}</span>
                    </div>
                )}
                {/* Partnership Terms */}
                <div style={{ width: 160, fontSize: 12, color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={deal.partnershipTerms || ''}>{deal.partnershipTerms || <span style={{ color: '#d1d5db' }}>—</span>}</div>
                {/* Cost */}
                <div style={{ fontWeight: 700, fontSize: 14, color: '#111827', width: 70, textAlign: 'right' }}>{fmtC(deal.cost)}</div>
                {/* Chevron */}
                <button onClick={() => setExpanded(!expanded)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, color: '#9ca3af', fontSize: 16, transition: 'transform 0.2s', transform: expanded ? 'rotate(180deg)' : 'none' }}>▾</button>
                {/* Menu */}
                <div style={{ position: 'relative' }}>
                    <button
                        onClick={e => { e.stopPropagation(); setMenuOpen(!menuOpen); }}
                        disabled={!canMutateCampaign}
                        title={canMutateCampaign ? 'Deal actions' : 'Campaign must be ACTIVE to modify deals'}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: canMutateCampaign ? 'pointer' : 'not-allowed',
                            padding: '4px 8px',
                            fontSize: 18,
                            color: '#9ca3af',
                            opacity: canMutateCampaign ? 1 : 0.5,
                        }}
                    >
                        ⋮
                    </button>
                    {menuOpen && (
                        <div style={{ position: 'absolute', right: 0, top: '100%', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', padding: 4, zIndex: 10, width: 170 }} onClick={e => e.stopPropagation()}>
                            {/* Deal lifecycle actions */}
                            {!isDealCanceled && (
                                <>
                                    {/* Active → Complete */}
                                    {canMutateDeal && (
                                        <button
                                            style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 12px', fontSize: 13, color: '#374151', background: 'none', border: 'none', cursor: 'pointer' }}
                                            onClick={() => {
                                                setMenuOpen(false);
                                                setConfirmAction('complete');
                                                setMarkCompleteConfirm(true);
                                            }}
                                        >
                                            ✓ Mark Complete
                                        </button>
                                    )}
                                    {/* Completed → Activate (reactivate) */}
                                    {canReactivateDeal && (
                                        <button
                                            style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 12px', fontSize: 13, color: '#374151', background: 'none', border: 'none', cursor: 'pointer' }}
                                            onClick={() => {
                                                setMenuOpen(false);
                                                setConfirmAction('reactivate');
                                                setMarkCompleteConfirm(true);
                                            }}
                                        >
                                            ⟲ Reactivate
                                        </button>
                                    )}
                                    {/* Active → Cancel */}
                                    {canMutateDeal && (
                                        <button
                                            style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 12px', fontSize: 13, color: '#dc2626', background: 'none', border: 'none', cursor: cancelling ? 'not-allowed' : 'pointer', opacity: cancelling ? 0.7 : 1 }}
                                            disabled={cancelling}
                                            onClick={handleCancelClick}
                                        >
                                            {cancelling ? 'Cancelling...' : '✗ Cancel Deal'}
                                        </button>
                                    )}
                                </>
                            )}

                            {/* Video collaborations require ACTIVE deal */}
                            {bcEnabled && canMutateDeal && (
                                <button
                                    style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 12px', fontSize: 13, color: '#dc2626', background: 'none', border: 'none', cursor: 'pointer' }}
                                    onClick={() => { setMenuOpen(false); onLinkVideo && onLinkVideo(deal); }}
                                >
                                    🔗 Link Video
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
            {/* Expanded */}
            {expanded && (
                <div style={{ padding: '14px 24px 18px', background: '#f9fafb', borderTop: '1px solid #f3f4f6' }}>
                    {/* Channel Stats */}
                    {(deal.subscriberCount != null || deal.channelViewCount != null || deal.channelVideoCount != null) && (
                        <div style={{ display: 'flex', gap: 16, marginBottom: 14 }}>
                            {deal.subscriberCount != null && (
                                <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 14px', textAlign: 'center', minWidth: 90 }}>
                                    <div style={{ fontSize: 15, fontWeight: 700, color: '#111827' }}>{fmtN(deal.subscriberCount)}</div>
                                    <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 2, textTransform: 'uppercase', fontWeight: 600 }}>Subscribers</div>
                                </div>
                            )}
                            {deal.channelViewCount != null && (
                                <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 14px', textAlign: 'center', minWidth: 90 }}>
                                    <div style={{ fontSize: 15, fontWeight: 700, color: '#111827' }}>{fmtN(deal.channelViewCount)}</div>
                                    <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 2, textTransform: 'uppercase', fontWeight: 600 }}>Channel Views</div>
                                </div>
                            )}
                            {deal.channelVideoCount != null && (
                                <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 14px', textAlign: 'center', minWidth: 90 }}>
                                    <div style={{ fontSize: 15, fontWeight: 700, color: '#111827' }}>{deal.channelVideoCount}</div>
                                    <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 2, textTransform: 'uppercase', fontWeight: 600 }}>Videos</div>
                                </div>
                            )}
                        </div>
                    )}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                        {deal.partnershipTerms && <div><div style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', marginBottom: 4 }}>Partnership Terms</div><p style={{ margin: 0, fontSize: 13, color: '#374151' }}>{deal.partnershipTerms}</p></div>}
                        <div><div style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', marginBottom: 4 }}>Timeline</div><div style={{ fontSize: 13, color: '#374151' }}>Created: {new Date(deal.createdAt).toLocaleDateString()}</div></div>
                    </div>
                    {bcEnabled && (
                        <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #e5e7eb' }}>
                            <button
                                onClick={() => onLinkVideo && onLinkVideo(deal)}
                                disabled={!canMutateDeal}
                                title={canMutateDeal ? 'Link a video to this deal' : 'Campaign + deal must be ACTIVE to link videos'}
                                style={{
                                    padding: '8px 16px',
                                    background: '#dc2626',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 8,
                                    fontSize: 13,
                                    fontWeight: 600,
                                    cursor: canMutateDeal ? 'pointer' : 'not-allowed',
                                    opacity: canMutateDeal ? 1 : 0.55,
                                }}
                            >
                                🔗 Link Video
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
        <ConfirmModal
            isOpen={markCompleteConfirm}
            title={confirmAction === 'reactivate' ? 'Reactivate deal?' : 'Mark deal as complete?'}
            message={confirmAction === 'reactivate'
                ? `This will re-activate the deal with ${deal.creatorName}.`
                : `This will mark the deal with ${deal.creatorName} as Complete. This cannot be undone.`}
            confirmLabel={confirmAction === 'reactivate' ? 'Reactivate' : 'Mark Complete'}
            loading={false}
            onConfirm={() => {
                setMarkCompleteConfirm(false);
                if (confirmAction === 'reactivate') {
                    onActivateDeal && onActivateDeal(deal);
                } else {
                    onMarkComplete && onMarkComplete(deal);
                }
            }}
            onClose={() => setMarkCompleteConfirm(false)}
        />
        </>
    );
}

// ---------- Videos Tab ----------
function VideosTab({ campaign, campaignId, videos, onRequestVideoLink, canRequestVideoLink, onUnlinkVideo, unlinkingVideoId, onSyncAll, syncingAll, onInsightsSaved }) {
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [editInsightsVideo, setEditInsightsVideo] = useState(null);
    const [unlinkConfirmVideo, setUnlinkConfirmVideo] = useState(null);
    if (!campaign.bcEnabled) return (
        <div style={{ textAlign: 'center', padding: 48, background: '#f9fafb', borderRadius: 12 }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🔒</div>
            <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Video Tracking Requires Creator Partnerships</div>
            <p style={{ color: '#6b7280', fontSize: 14, margin: 0 }}>Enable Creator Partnerships tracking to access verified YouTube video analytics.</p>
        </div>
    );
    const linked = videos.filter(v => v.consentStatus === 'ACTIVE');
    const pending = videos.filter(v => v.consentStatus === 'PENDING');
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            {/* Summary */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12 }}>
                {[{ icon: '🎬', label: 'Total Videos', value: videos.length, bg: '#f9fafb', color: '#111827' },
                { icon: '✓', label: 'Linked', value: linked.length, bg: '#f0fdf4', color: '#16a34a' },
                { icon: '⏳', label: 'Pending Consent', value: pending.length, bg: '#fffbeb', color: '#d97706' },
                { icon: '👁', label: 'Total Views', value: fmtN(linked.reduce((s, v) => s + (v.metrics?.views ?? 0), 0)), bg: '#eef2ff', color: '#4f46e5' }].map(s => (
                    <div key={s.label} style={{ background: s.bg, borderRadius: 12, padding: '16px 12px', textAlign: 'center', border: '1px solid #f3f4f6' }}>
                        <div style={{ fontSize: 20, marginBottom: 4 }}>{s.icon}</div>
                        <div style={{ fontSize: 22, fontWeight: 700, color: s.color }}>{s.value}</div>
                        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>{s.label}</div>
                    </div>
                ))}
            </div>
            {/* Table header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ fontWeight: 700, fontSize: 15 }}>Video Collaborations</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <button
                        onClick={onSyncAll}
                        disabled={syncingAll || videos.length === 0}
                        title="Sync all video stats from Creator Partnerships"
                        style={{
                            padding: '8px 16px',
                            background: '#eff6ff',
                            color: '#1d4ed8',
                            border: '1px solid #bfdbfe',
                            borderRadius: 8,
                            fontSize: 13,
                            fontWeight: 600,
                            cursor: (syncingAll || videos.length === 0) ? 'not-allowed' : 'pointer',
                            opacity: (syncingAll || videos.length === 0) ? 0.6 : 1,
                        }}
                    >
                        {syncingAll ? 'Syncing...' : '🔄 Sync All'}
                    </button>
                    <button
                        onClick={onRequestVideoLink}
                        disabled={!canRequestVideoLink}
                        title={canRequestVideoLink ? 'Request video link from a creator deal' : 'Add a creator deal first to request a video link'}
                        style={{
                            padding: '8px 16px',
                            background: '#dc2626',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 8,
                            fontSize: 13,
                            fontWeight: 600,
                            cursor: canRequestVideoLink ? 'pointer' : 'not-allowed',
                            opacity: canRequestVideoLink ? 1 : 0.55,
                        }}
                    >
                        + Request Video Link
                    </button>
                </div>
            </div>
            {videos.length === 0 ? (
                <div style={{ textAlign: 'center', padding: 32, background: '#f9fafb', borderRadius: 12 }}>
                    <div style={{ fontSize: 36, marginBottom: 8 }}>🎬</div>
                    <div style={{ fontWeight: 600 }}>No videos yet</div>
                    <p style={{ color: '#6b7280', fontSize: 13, margin: 0 }}>Request creators to link their videos to this campaign</p>
                </div>
            ) : (
                <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead><tr style={{ background: '#f9fafb' }}>
                            {['Video', 'Status', 'Views', '🌱 Organic', '💰 Paid', 'Eng. Rate', 'Actions'].map((h, i) => (
                                <th key={i} style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', textAlign: i === 0 ? 'left' : 'center', whiteSpace: 'nowrap' }}>{h}</th>
                            ))}
                        </tr></thead>
                        <tbody>
                            {videos.map(v => {
                                const cs = CONSENT[v.consentStatus] || CONSENT.PENDING;
                                return (
                                    <tr key={v.id} style={{ borderTop: '1px solid #f3f4f6' }}>
                                        <td style={{ padding: '12px 16px', maxWidth: 240 }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                {v.youtubeVideoId && (
                                                    <a href={`https://youtube.com/watch?v=${v.youtubeVideoId}`} target="_blank" rel="noreferrer"
                                                        style={{ flexShrink: 0, width: 28, height: 28, background: '#fee2e2', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none', color: '#dc2626', fontSize: 12, fontWeight: 700 }}
                                                        onClick={e => e.stopPropagation()}>▶</a>
                                                )}
                                                <div style={{ minWidth: 0 }}>
                                                    <div style={{ fontWeight: 600, fontSize: 13, color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        {v.title || v.youtubeVideoId || '—'}
                                                    </div>
                                                    <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>
                                                        {v.creatorName || v.channelId || '—'} · {v.publishedAt || '—'}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                                            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                                <span style={{ padding: '2px 8px', background: cs.bg, color: cs.color, fontSize: 11, fontWeight: 700, borderRadius: 20 }}>{cs.icon} {cs.label}</span>
                                                {v.promoted && <span style={{ padding: '2px 8px', background: '#eef2ff', color: '#4f46e5', fontSize: 11, fontWeight: 700, borderRadius: 20 }}>Promoted</span>}
                                            </div>
                                        </td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center', fontWeight: 600, fontSize: 14 }}>{fmtN(v.metrics?.views)}</td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                                            {v.trafficSplit?.organic != null
                                                ? <span style={{ fontWeight: 600, color: '#16a34a', fontSize: 14 }}>{v.trafficSplit.organic}% <span style={{ fontSize: 11, color: '#9ca3af', fontWeight: 400 }}>({fmtN(v.trafficSplit.organicViews)})</span></span>
                                                : <span style={{ color: '#9ca3af' }}>—</span>}
                                        </td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                                            {v.trafficSplit?.paid != null
                                                ? <span style={{ fontWeight: 600, color: '#4f46e5', fontSize: 14 }}>{v.trafficSplit.paid}% <span style={{ fontSize: 11, color: '#9ca3af', fontWeight: 400 }}>({fmtN(v.trafficSplit.paidViews)})</span></span>
                                                : <span style={{ color: '#9ca3af' }}>—</span>}
                                        </td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center', fontWeight: 600, fontSize: 14 }}>
                                            <span title="Engagement Rate = (Likes + Comments + Shares) / Views">
                                                {safeN(v.metrics?.views) > 0
                                                    ? `${(
                                                        (safeN(v.metrics?.likes) +
                                                        safeN(v.metrics?.comments) +
                                                        safeN(v.metrics?.shares)) /
                                                        safeN(v.metrics?.views) *
                                                        100
                                                    ).toFixed(2)}%`
                                                    : '0.00%'}
                                                </span>
                                        </td>
                                        <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                                            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                                {v.consentStatus === 'ACTIVE' && <button onClick={() => setSelectedVideo(v)} style={{ padding: '6px 12px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>Insights</button>}
                                                {FEATURE_YT_ADSTATS && v.consentStatus === 'ACTIVE' && <button onClick={() => setEditInsightsVideo(v)} style={{ padding: '6px 12px', background: '#eef2ff', color: '#4f46e5', border: '1px solid #c7d2fe', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>Edit insights</button>}
                                                <button
                                                    onClick={() => { if (!onUnlinkVideo) return; setUnlinkConfirmVideo(v); }}
                                                    disabled={unlinkingVideoId === v.id}
                                                    style={{
                                                        padding: '6px 12px',
                                                        background: '#fee2e2',
                                                        color: '#b91c1c',
                                                        border: '1px solid #fecaca',
                                                        borderRadius: 6,
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        cursor: unlinkingVideoId === v.id ? 'not-allowed' : 'pointer',
                                                        opacity: unlinkingVideoId === v.id ? 0.7 : 1,
                                                    }}
                                                >
                                                    {unlinkingVideoId === v.id ? 'Unlinking...' : 'Unlink Video'}
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
            {selectedVideo && <VideoInsightsModal video={selectedVideo} onClose={() => setSelectedVideo(null)} />}
            {editInsightsVideo && (
                <EditVideoInsightsModal
                    isOpen
                    video={editInsightsVideo}
                    campaignId={campaignId}
                    onClose={() => setEditInsightsVideo(null)}
                    onSaved={() => onInsightsSaved && onInsightsSaved()}
                />
            )}
            <ConfirmModal
                isOpen={Boolean(unlinkConfirmVideo)}
                title="Unlink this video?"
                message="This will remove the linked video from this campaign."
                confirmLabel="Unlink Video"
                danger
                loading={unlinkingVideoId === unlinkConfirmVideo?.id}
                onConfirm={() => { onUnlinkVideo(unlinkConfirmVideo); setUnlinkConfirmVideo(null); }}
                onClose={() => setUnlinkConfirmVideo(null)}
            />
        </div>
    );
}

// ---------- Reports Tab ----------
const REPORT_DATA = {
    totalViews: '388.6K', engagementRate: '5.1%', watchTime: '2.8K hrs', costPerView: '₹1.16',
    organicPct: 78, organicViews: '302.5K', paidViews: '86.1K',
    organicEngagement: '6.2%', organicDuration: '4m 47s', paidEngagement: '3.4%', paidDuration: '2m 45s',
    viewsOverTime: [
        // { date: 'Jan 15', organic: 45000, paid: 12000 },
        // { date: 'Jan 22', organic: 82000, paid: 28000 },
        // { date: 'Jan 29', organic: 125000, paid: 45000 },
        // { date: 'Feb 5', organic: 180000, paid: 62000 },
        // { date: 'Feb 12', organic: 220000, paid: 58000 },
        // { date: 'Feb 19', organic: 284000, paid: 59000 },
    ],
    ageDistribution: [
        // { age: '18-24', pct: 18 }, { age: '25-34', pct: 42 },
        // { age: '35-44', pct: 26 }, { age: '45-54', pct: 10 }, { age: '55+', pct: 4 },
    ],
    videos: [
        // { id: 'v1', title: 'TTK Prestige Cooker Review 2026', creator: 'CookWithAnjali', views: '145.2K', organicPct: 76, engagement: '6.8%' },
        // { id: 'v2', title: '5 Dishes with TTK Prestige', creator: 'HomeDecorByRiya', views: '98.4K', organicPct: 80, engagement: '7.2%' },
        // { id: 'v3', title: 'Honest Review: Worth the Hype?', creator: 'TechReviewIndia', views: '62.0K', organicPct: 74, engagement: '5.4%' },
    ],
};

function normalizeReportData(reportData, videos) {
    const allVideos = (videos || []);
    const videoViews = allVideos.reduce((sum, v) => sum + safeN(v.metrics?.views), 0);
    const videoOrganicViews = allVideos.reduce((sum, v) => sum + safeN(v.trafficSplit?.organicViews), 0);
    const videoPaidViews = allVideos.reduce((sum, v) => sum + safeN(v.trafficSplit?.paidViews), 0);
    const videoWatchTime = allVideos.reduce((sum, v) => sum + safeN(v.metrics?.watchTimeHours), 0);
    const videoLikes = allVideos.reduce((sum, v) => sum + safeN(v.metrics?.likes), 0);
    const videoComments = allVideos.reduce((sum, v) => sum + safeN(v.metrics?.comments), 0);
    const videoEngagementRate = videoViews > 0 ? ((videoLikes + videoComments) / videoViews) * 100 : 0;

    // Use report API data only if it has meaningful (non-zero) views, otherwise use video-derived metrics
    const reportHasData = safeN(reportData?.total_views || reportData?.totalViews || reportData?.views) > 0;
    const rd = reportHasData ? reportData : null;

    const totalViews = firstN(rd?.total_views, rd?.totalViews, rd?.views, videoViews, 0) || 0;
    const organicViews = firstN(rd?.organic_views, rd?.organicViews, videoOrganicViews);
    const paidViews = firstN(
        rd?.paid_views,
        rd?.paidViews,
        videoPaidViews,
        totalViews > 0 && organicViews != null ? totalViews - organicViews : null,
    );
    const organicPct = firstN(
        rd?.organic_percent,
        rd?.organicPct,
        totalViews > 0 && organicViews != null ? Math.round((organicViews / totalViews) * 100) : null,
        0,
    ) || 0;
    const paidPct = Math.max(0, 100 - organicPct);

    const engagementRate = firstN(
        rd?.engagement_rate,
        rd?.total_engagement_rate,
        rd?.engagementRate,
        videoEngagementRate,
        0,
    ) || 0;
    const watchTimeHours = firstN(rd?.watch_time_hours, rd?.watchTimeHours, videoWatchTime, 0) || 0;
    const costPerView = firstN(rd?.cost_per_view, rd?.costPerView);

    const viewsOverTime = (Array.isArray(rd?.views_over_time) ? rd.views_over_time :
        (Array.isArray(rd?.viewsOverTime) ? rd.viewsOverTime :
            (Array.isArray(rd?.timeline) ? rd.timeline : [])))
        .map(item => ({
            date: item.date || item.label || item.day || '',
            organic: safeN(firstN(item.organic, item.organic_views, item.organicViews, 0)),
            paid: safeN(firstN(item.paid, item.paid_views, item.paidViews, 0)),
        }))
        .filter(item => item.date);

    const ageDistributionRaw = Array.isArray(rd?.age_distribution)
        ? rd.age_distribution
        : (Array.isArray(rd?.ageDistribution) ? rd.ageDistribution : null);
    const ageDistribution = ageDistributionRaw
        ? ageDistributionRaw.map(item => ({ age: item.age || item.range || '', pct: safeN(firstN(item.pct, item.percentage, 0)) }))
        : REPORT_DATA.ageDistribution;

    const reportVideos = Array.isArray(rd?.videos)
        ? rd.videos
        : (Array.isArray(rd?.items) ? rd.items : allVideos);
    const normalizedVideos = reportVideos.map(v => {
        const vViews = firstN(v.views, v.view_count, v.total_views, v.metrics?.views, 0) || 0;
        const vOrganicPct = firstN(
            v.organicPct,
            v.organic_percent,
            v.trafficSplit?.organic,
            vViews > 0 ? Math.round((safeN(firstN(v.organic_views, v.trafficSplit?.organicViews, 0)) / vViews) * 100) : null,
            0,
        ) || 0;
        const vEngagement = firstN(
            v.engagement_rate,
            v.engagementRate,
            v.metrics?.engagementRate != null ? safeN(v.metrics.engagementRate) * 100 : null,
            0,
        ) || 0;

        return {
            id: v.id || v.youtube_video_id || v.youtubeVideoId || Math.random().toString(36).slice(2),
            title: v.title || v.youtube_video_id || v.youtubeVideoId || '—',
            creator: v.creator || v.creator_name || v.creatorName || v.channelId || '—',
            views: fmtN(vViews),
            organicPct: vOrganicPct,
            engagement: `${vEngagement.toFixed(2)}%`,
        };
    });

    const fmtPct = (v) => `${safeN(v).toFixed(1)}%`;

    // Google Ads "Partnership Ads" — separate paid-stats block on the report response,
    // never folded into the organic/paid split above.
    const gaRaw = rd?.google_ads || null;
    const googleAds = gaRaw ? {
        views: safeN(gaRaw.views),
        impressions: safeN(gaRaw.impressions),
        clicks: safeN(gaRaw.clicks),
        spend: safeN(gaRaw.spend),
        conversions: safeN(gaRaw.conversions),
        promotedVideos: safeN(gaRaw.promoted_videos),
    } : null;

    return {
        totalViews: fmtN(totalViews),
        engagementRate: fmtPct(engagementRate),
        watchTime: fmtH(watchTimeHours),
        costPerView: costPerView != null ? `₹${safeN(costPerView).toFixed(2)}` : '-',
        organicPct,
        paidPct,
        organicViews: organicViews != null ? fmtN(organicViews) : '-',
        paidViews: paidViews != null ? fmtN(paidViews) : '-',
        // Raw (unformatted) view counts — needed to recompute percentages when the
        // Google Ads segment is present.
        organicViewsRaw: safeN(organicViews),
        paidViewsRaw: safeN(paidViews),
        googleAds,
        organicEngagement: rd?.organic_engagement_rate != null ? fmtPct(rd.organic_engagement_rate) : '-',
        organicDuration: rd?.organic_avg_view_duration != null ? fmtT(rd.organic_avg_view_duration) : '-',
        paidEngagement: rd?.paid_engagement_rate != null ? fmtPct(rd.paid_engagement_rate) : '-',
        paidDuration: rd?.paid_avg_view_duration != null ? fmtT(rd.paid_avg_view_duration) : '-',
        viewsOverTime: viewsOverTime.length > 0 ? viewsOverTime : REPORT_DATA.viewsOverTime,
        ageDistribution,
        videos: normalizedVideos.length > 0 ? normalizedVideos : REPORT_DATA.videos,
    };
}

function SvgLineChart({ data }) {
    const W = 600, H = 180, PAD = { t: 10, r: 10, b: 30, l: 50 };
    const innerW = W - PAD.l - PAD.r;
    const innerH = H - PAD.t - PAD.b;
    const safeData = (Array.isArray(data) && data.length > 0) ? data : [{ date: 'Now', organic: 0, paid: 0 }];
    const maxVal = Math.max(1, ...safeData.map(d => safeN(d.organic) + safeN(d.paid)));
    const xStep = safeData.length > 1 ? innerW / (safeData.length - 1) : 0;
    const scaleY = v => innerH - (v / maxVal) * innerH;
    const pts = (key) => safeData.map((d, i) => `${i * xStep},${scaleY(safeN(d[key]))}`).join(' ');
    const area = (key, color) => {
        const points = safeData.map((d, i) => [i * xStep, scaleY(safeN(d[key]))]);
        const pathD = points.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x},${y}`).join(' ')
            + ` L${(safeData.length - 1) * xStep},${innerH} L0,${innerH} Z`;
        return <path d={pathD} fill={color} fillOpacity={0.08} />;
    };
    return (
        <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: 180, overflow: 'visible' }}>
            <g transform={`translate(${PAD.l},${PAD.t})`}>
                {/* Gridlines */}
                {[0, 0.25, 0.5, 0.75, 1].map(t => (
                    <g key={t}>
                        <line x1={0} y1={innerH * t} x2={innerW} y2={innerH * t} stroke="#f3f4f6" strokeWidth={1} />
                        <text x={-6} y={innerH * t + 4} fontSize={10} fill="#9ca3af" textAnchor="end">
                            {fmtN(Math.round(maxVal * (1 - t)))}
                        </text>
                    </g>
                ))}
                {/* Area fills */}
                {area('organic', '#22c55e')}
                {area('paid', '#6366f1')}
                {/* Lines */}
                <polyline points={pts('organic')} fill="none" stroke="#22c55e" strokeWidth={2} strokeLinejoin="round" />
                <polyline points={pts('paid')} fill="none" stroke="#6366f1" strokeWidth={2} strokeLinejoin="round" />
                {/* Dots */}
                {safeData.map((d, i) => (
                    <g key={i}>
                        <circle cx={i * xStep} cy={scaleY(d.organic)} r={3} fill="#22c55e" />
                        <circle cx={i * xStep} cy={scaleY(d.paid)} r={3} fill="#6366f1" />
                        <text x={i * xStep} y={innerH + 16} fontSize={10} fill="#9ca3af" textAnchor="middle">{d.date}</text>
                    </g>
                ))}
            </g>
        </svg>
    );
}

function ReportsTab({ campaign, deals, videos, reportData }) {
    const r = normalizeReportData(reportData, videos);
    const paidPct = r.paidPct;

    // Google Ads "Partnership Ads" — a third, visibly-separate traffic segment.
    // Only kicks in when the report actually has GA views; otherwise everything
    // below renders exactly as it did before this block existed.
    const hasGA = !!(r.googleAds && r.googleAds.views > 0);
    const gaViewsN = hasGA ? r.googleAds.views : 0;
    const orgViewsN = safeN(r.organicViewsRaw);
    const paidViewsN = safeN(r.paidViewsRaw);
    const totalViewsN = orgViewsN + paidViewsN + gaViewsN;
    const organicPct3 = hasGA && totalViewsN > 0 ? Math.round((orgViewsN / totalViewsN) * 100) : r.organicPct;
    const paidPct3 = hasGA && totalViewsN > 0 ? Math.round((paidViewsN / totalViewsN) * 100) : paidPct;
    const gaPct3 = hasGA ? Math.max(0, 100 - organicPct3 - paidPct3) : 0;

    const exportCSV = () => {
        const rows = [
            ['Title', 'Creator', 'Views', 'Organic %', 'Engagement'],
            ...r.videos.map(v => [v.title, v.creator, v.views, v.organicPct + '%', v.engagement]),
        ];
        const csv = rows.map(r => r.join(',')).join('\n');
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a'); a.href = url; a.download = 'campaign_report.csv'; a.click();
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                    <div style={{ fontWeight: 700, fontSize: 16 }}>Campaign Reports</div>
                    <div style={{ fontSize: 13, color: '#9ca3af', marginTop: 2 }}>Analyze performance with organic/paid traffic split</div>
                </div>
                <button onClick={exportCSV} style={{ padding: '8px 16px', background: '#dc2626', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                    Export Full Report
                </button>
            </div>

            {/* Key Metrics */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12 }}>
                {[
                    { label: 'Total Views', value: r.totalViews, sub: '+12% vs last month', subColor: '#16a34a', icon: '👁' },
                    { label: 'Engagement Rate', value: r.engagementRate, sub: 'Above average', subColor: '#16a34a', icon: '📈' },
                    { label: 'Watch Time', value: r.watchTime, sub: 'Total hours', subColor: '#9ca3af', icon: '⏱' },
                    { label: 'Cost per View', value: r.costPerView, sub: '-8% vs benchmark', subColor: '#16a34a', icon: '💰' },
                ].map(m => (
                    <div key={m.label} style={{ background: '#fff', border: '1px solid #f3f4f6', borderRadius: 12, padding: 16 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
                            <span style={{ fontSize: 16 }}>{m.icon}</span>
                            <div style={{ fontSize: 12, color: '#6b7280' }}>{m.label}</div>
                        </div>
                        <div style={{ fontSize: 24, fontWeight: 700, color: '#111827', marginBottom: 4 }}>{m.value}</div>
                        <div style={{ fontSize: 11, color: m.subColor }}>{m.sub}</div>
                    </div>
                ))}
            </div>

            {/* Traffic Split */}
            <div style={{ background: '#fff', border: '1px solid #f3f4f6', borderRadius: 12, padding: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
                    <div style={{ fontWeight: 700, fontSize: 15 }}>Organic vs Paid Traffic</div>
                    <span style={{ padding: '2px 8px', background: '#fef2f2', color: '#dc2626', fontSize: 10, fontWeight: 700, borderRadius: 4, border: '1px solid #fecaca' }}>YCP Exclusive</span>
                </div>
                <div style={{ display: 'flex', height: 36, borderRadius: 8, overflow: 'hidden', marginBottom: hasGA ? 12 : 16 }}>
                    {hasGA ? (
                        <>
                            <div style={{ width: `${organicPct3}%`, background: '#22c55e', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 13, fontWeight: 700 }}>
                                {organicPct3 > 15 && `🌱 Organic ${organicPct3}%`}
                            </div>
                            <div style={{ width: `${paidPct3}%`, background: '#6366f1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 13, fontWeight: 700 }}>
                                {paidPct3 > 15 && `💰 Paid ${paidPct3}%`}
                            </div>
                            <div style={{ width: `${gaPct3}%`, background: '#4f46e5', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 13, fontWeight: 700 }}>
                                {gaPct3 > 15 && `📢 Google Ads ${gaPct3}%`}
                            </div>
                        </>
                    ) : (
                        <>
                            <div style={{ width: `${r.organicPct}%`, background: '#22c55e', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 13, fontWeight: 700 }}>
                                🌱 Organic {r.organicPct}%
                            </div>
                            <div style={{ width: `${paidPct}%`, background: '#6366f1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 13, fontWeight: 700 }}>
                                💰 Paid {paidPct}%
                            </div>
                        </>
                    )}
                </div>
                {hasGA && (
                    <div style={{ marginBottom: 16 }}>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 8 }}>
                            Total Views (Organic + Paid + Google Ads): <strong style={{ color: '#111827' }}>{fmtN(totalViewsN)}</strong>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                            {[
                                { color: '#22c55e', label: 'Organic', views: orgViewsN, pct: organicPct3 },
                                { color: '#6366f1', label: 'Paid', views: paidViewsN, pct: paidPct3 },
                                { color: '#4f46e5', label: 'Google Ads Paid', views: gaViewsN, pct: gaPct3 },
                            ].map(row => (
                                <div key={row.label} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12 }}>
                                    <div style={{ width: 10, height: 10, borderRadius: 3, background: row.color, flexShrink: 0 }} />
                                    <span style={{ color: '#374151', flex: 1 }}>{row.label}</span>
                                    <span style={{ color: '#6b7280' }}>{fmtN(row.views)}</span>
                                    <span style={{ fontWeight: 700, color: row.color, width: 40, textAlign: 'right' }}>{row.pct}%</span>
                                </div>
                            ))}
                        </div>
                        <div style={{ marginTop: 8, fontSize: 11, color: '#9ca3af' }}>
                            Google Ads is reported from the brand&apos;s ad account, separately from BrandConnect.
                        </div>
                    </div>
                )}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                    <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 10, padding: 14 }}>
                        <div style={{ fontWeight: 700, color: '#15803d', marginBottom: 10 }}>Organic Performance</div>
                        {[['Views', r.organicViews], ['Engagement', r.organicEngagement], ['Avg Duration', r.organicDuration]].map(([l, v]) => (
                            <div key={l} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
                                <span style={{ color: '#16a34a' }}>{l}</span><strong>{v}</strong>
                            </div>
                        ))}
                    </div>
                    <div style={{ background: '#eef2ff', border: '1px solid #a5b4fc', borderRadius: 10, padding: 14 }}>
                        <div style={{ fontWeight: 700, color: '#4338ca', marginBottom: 10 }}>Paid Performance</div>
                        {[['Views', r.paidViews], ['Engagement', r.paidEngagement], ['Avg Duration', r.paidDuration]].map(([l, v]) => (
                            <div key={l} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
                                <span style={{ color: '#4f46e5' }}>{l}</span><strong>{v}</strong>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Views Over Time Chart */}
            <div style={{ background: '#fff', border: '1px solid #f3f4f6', borderRadius: 12, padding: 20 }}>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12 }}>Views Over Time</div>
                <div style={{ display: 'flex', gap: 16, marginBottom: 10 }}>
                    {[{ color: '#22c55e', label: 'Organic' }, { color: '#6366f1', label: 'Paid' }].map(l => (
                        <div key={l.label} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                            <div style={{ width: 12, height: 3, background: l.color, borderRadius: 2 }} />
                            <span style={{ fontSize: 12, color: '#6b7280' }}>{l.label}</span>
                        </div>
                    ))}
                </div>
                <SvgLineChart data={r.viewsOverTime} />
            </div>

            {/* Audience Demographics */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                {/* Age Distribution */}
                <div style={{ background: '#fff', border: '1px solid #f3f4f6', borderRadius: 12, padding: 20 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 14 }}>Age Distribution</div>
                    {r.ageDistribution.map(({ age, pct }) => (
                        <div key={age} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                            <span style={{ fontSize: 12, color: '#6b7280', width: 36 }}>{age}</span>
                            <div style={{ flex: 1, height: 20, background: '#f3f4f6', borderRadius: 4, overflow: 'hidden' }}>
                                <div style={{ width: `${pct}%`, height: '100%', background: '#ef4444', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: 4 }}>
                                    {pct >= 10 && <span style={{ fontSize: 10, color: '#fff', fontWeight: 700 }}>{pct}%</span>}
                                </div>
                            </div>
                            {pct < 10 && <span style={{ fontSize: 11, color: '#6b7280', width: 26 }}>{pct}%</span>}
                        </div>
                    ))}
                </div>

                {/* Gender Distribution */}
                <div style={{ background: '#fff', border: '1px solid #f3f4f6', borderRadius: 12, padding: 20 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 14 }}>Gender Distribution</div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 24 }}>
                        {/* SVG Donut */}
                        <svg width={120} height={120} viewBox="0 0 42 42">
                            <circle cx="21" cy="21" r="15.91" fill="transparent" stroke="#3b82f6" strokeWidth="10"
                                strokeDasharray="58 42" strokeDashoffset="25" />
                            <circle cx="21" cy="21" r="15.91" fill="transparent" stroke="#ec4899" strokeWidth="10"
                                strokeDasharray="42 58" strokeDashoffset="-33" />
                            <text x="21" y="23" textAnchor="middle" fontSize="5" fontWeight="bold" fill="#374151">Gender</text>
                        </svg>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div style={{ width: 12, height: 12, background: '#3b82f6', borderRadius: 2 }} />
                                <span style={{ fontSize: 13, color: '#374151' }}>Male</span>
                                <span style={{ fontSize: 18, fontWeight: 700, color: '#2563eb', marginLeft: 6 }}>0%</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div style={{ width: 12, height: 12, background: '#ec4899', borderRadius: 2 }} />
                                <span style={{ fontSize: 13, color: '#374151' }}>Female</span>
                                <span style={{ fontSize: 18, fontWeight: 700, color: '#db2777', marginLeft: 6 }}>0%</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: 20, background: '#f9fafb', borderRadius: 8, padding: 12 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', marginBottom: 8 }}>Top Countries</div>
                        {[
                            ['India', 0], ['USA', 0], ['UK', 0], ['UAE', 0]].map(([c, p]) => (
                            <div key={c} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
                                <span style={{ color: '#374151' }}>{c}</span><span style={{ fontWeight: 600 }}>{p}%</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Video Performance Table */}
            <div style={{ background: '#fff', border: '1px solid #f3f4f6', borderRadius: 12, padding: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                    <div style={{ fontWeight: 700, fontSize: 15 }}>Video Performance</div>
                    <button onClick={exportCSV} style={{ padding: '6px 14px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>Export CSV</button>
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                        <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                            {['Video', 'Creator', 'Views', 'Organic %', 'Engagement'].map((h, i) => (
                                <th key={h} style={{ padding: '8px 12px', fontWeight: 700, color: '#6b7280', textAlign: i < 2 ? 'left' : 'right', fontSize: 12 }}>{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {r.videos.map(v => (
                            <tr key={v.id} style={{ borderBottom: '1px solid #f9fafb' }}>
                                <td style={{ padding: '10px 12px', fontWeight: 600, color: '#111827', maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.title}</td>
                                <td style={{ padding: '10px 12px', color: '#6b7280' }}>{v.creator}</td>
                                <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600 }}>{v.views}</td>
                                <td style={{ padding: '10px 12px', textAlign: 'right' }}>
                                    <span style={{ color: '#16a34a', fontWeight: 700 }}>{v.organicPct}%</span>
                                </td>
                                <td style={{ padding: '10px 12px', textAlign: 'right', color: '#374151' }}>{v.engagement}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

// ---------- Shortlist Creator Modal ----------
const CURRENCIES = ['INR', 'USD', 'EUR', 'GBP'];
const DEAL_LINK_LABELS = ['LEARN_MORE', 'BUY_NOW', 'SIGN_UP', 'SHOP_NOW', 'VISIT_SITE'];
const INCENTIVE_OPTIONS = [
    { key: 'flat_fee', label: 'Flat Fee', desc: 'Fixed monetary payment' },
    { key: 'gift', label: 'Gift', desc: 'Non-monetary gift' },
    { key: 'affiliate', label: 'Affiliate', desc: 'Commission-based earnings' },
    { key: 'other', label: 'Other', desc: 'Other incentive type' },
];

function ShortlistCreatorModal({ isOpen, onClose, campaignId, bcEnabled, onCreated }) {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [form, setForm] = useState({
        influencer_id: '',
        creator_channel_id: '',
        expected_video_count: 1,
        creator_cost_units: '',
        creator_cost_currency: 'INR',
        partnership_terms: '',
        deal_link_uri: '',
        deal_link_label: 'LEARN_MORE',
        incentives: { flat_fee: false, gift: false, affiliate: false, other: false },
    });
    const toggleIncentive = (key) => setForm(f => ({ ...f, incentives: { ...f.incentives, [key]: !f.incentives[key] } }));
    const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

    const handleSubmit = async () => {
        if (!form.creator_channel_id.trim()) { setError('Creator channel ID is required.'); return; }
        if (!form.creator_cost_units) { setError('Cost is required.'); return; }
        setError('');
        setSaving(true);
        const payload = {
            influencer_id: form.influencer_id ? Number(form.influencer_id) : undefined,
            channelId: form.creator_channel_id.trim(),
            expectedVideos: Number(form.expected_video_count),
            cost: { amount: Number(form.creator_cost_units), currency: form.creator_cost_currency },
            partnershipTerms: form.partnership_terms.trim(),
            ...(bcEnabled && form.deal_link_uri.trim()
                ? { dealLink: { uri: form.deal_link_uri.trim(), label: form.deal_link_label } }
                : {}),
        };
        try {
            const deal = await shortlistPlannerCreator(campaignId, payload);
            mixpanel.track('campaign_deal_influencer_added', {
                campaign_id: campaignId,
                deal_id: deal?.id,
                creator_channel_id: form.creator_channel_id.trim(),
                bc_enabled: bcEnabled,
            });
            onCreated && onCreated(deal);
            toast.success('Creator added successfully');
            onClose();
            window.location.reload();
        } catch (e) {
            const message = e?.message || 'Failed to add creator. Please try again.';
            setError(message);
            toast.error(message);
        } finally {
            setSaving(false);
        }
    };

    if (!isOpen) return null;
    const fs = { width: '100%', padding: '9px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' };

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 16 }} onClick={onClose}>
            <div style={{ background: '#fff', borderRadius: 20, width: '100%', maxWidth: 480, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
                <div style={{ padding: '20px 24px 14px', borderBottom: '1px solid #f3f4f6', position: 'sticky', top: 0, background: '#fff', zIndex: 1 }}>
                    <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#111827' }}>Add Creator</h2>
                    <p style={{ margin: '4px 0 0', fontSize: 13, color: '#9ca3af' }}>Shortlist a creator for this campaign{bcEnabled ? ' — a YCP deal will be created automatically' : ''}</p>
                </div>
                <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 14 }}>
                    {error && <div style={{ padding: '10px 14px', background: '#fee2e2', borderRadius: 8, fontSize: 13, color: '#991b1b' }}>{error}</div>}
                    <div>
                        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Influencer ID (optional)</label>
                        <input type="number" placeholder="e.g. 10" value={form.influencer_id} onChange={e => set('influencer_id', e.target.value)} style={fs} />
                    </div>
                    <div>
                        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.4px' }}>YouTube Channel ID *</label>
                        <input type="text" placeholder="UCxxxxxxxxxxxxxxxxxx" value={form.creator_channel_id} onChange={e => set('creator_channel_id', e.target.value)} style={fs} />
                    </div>
                    <div>
                        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Expected Videos</label>
                        <input type="number" min={1} value={form.expected_video_count} onChange={e => set('expected_video_count', e.target.value)} style={fs} />
                    </div>
                    <div>
                        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Cost *</label>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 90px', gap: 8 }}>
                            <input type="number" min={0} placeholder="150000" value={form.creator_cost_units} onChange={e => set('creator_cost_units', e.target.value)} style={fs} />
                            <select value={form.creator_cost_currency} onChange={e => set('creator_cost_currency', e.target.value)} style={fs}>
                                {CURRENCIES.map(c => <option key={c} value={c}>{c}</option>)}
                            </select>
                        </div>
                    </div>
                    <div>
                        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Partnership Terms</label>
                        <textarea rows={2} placeholder="e.g. 3 dedicated videos over 4 weeks" value={form.partnership_terms} onChange={e => set('partnership_terms', e.target.value)} style={{ ...fs, resize: 'vertical' }} />
                    </div>
                    <div>
                        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Incentives <span style={{ fontWeight: 400, textTransform: 'none', color: '#9ca3af', fontSize: 11 }}>(optional)</span></label>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                            {INCENTIVE_OPTIONS.map(opt => (
                                <label key={opt.key} onClick={() => toggleIncentive(opt.key)} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '9px 12px', border: `1.5px solid ${form.incentives[opt.key] ? '#dc2626' : '#e5e7eb'}`, borderRadius: 8, background: form.incentives[opt.key] ? '#fff5f5' : '#fff', cursor: 'pointer', userSelect: 'none' }}>
                                    <input type="checkbox" checked={form.incentives[opt.key]} onChange={() => toggleIncentive(opt.key)} style={{ marginTop: 2, accentColor: '#dc2626', cursor: 'pointer' }} />
                                    <div>
                                        <div style={{ fontSize: 13, fontWeight: 600, color: '#111827' }}>{opt.label}</div>
                                        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 1 }}>{opt.desc}</div>
                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>
                    {bcEnabled && (
                        <div style={{ padding: 14, background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10 }}>
                            <div style={{ fontSize: 12, fontWeight: 700, color: '#dc2626', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 6 }}>
                                <span style={{ padding: '1px 5px', background: '#dc2626', color: '#fff', fontSize: 9, borderRadius: 3 }}>YCP</span>
                                Promo Link (optional)
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                <input type="url" placeholder="https://example.com/promo" value={form.deal_link_uri} onChange={e => set('deal_link_uri', e.target.value)} style={fs} />
                                <select value={form.deal_link_label} onChange={e => set('deal_link_label', e.target.value)} style={fs}>
                                    {DEAL_LINK_LABELS.map(l => <option key={l} value={l}>{l}</option>)}
                                </select>
                            </div>
                        </div>
                    )}
                </div>
                <div style={{ padding: '14px 24px', borderTop: '1px solid #f3f4f6', display: 'flex', justifyContent: 'flex-end', gap: 10, position: 'sticky', bottom: 0, background: '#fff' }}>
                    <button onClick={onClose} disabled={saving} style={{ padding: '9px 18px', background: '#f9fafb', color: '#374151', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>Cancel</button>
                    <button onClick={handleSubmit} disabled={saving} style={{ padding: '9px 18px', background: '#dc2626', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: saving ? 0.7 : 1 }}>
                        {saving ? 'Adding...' : 'Add Creator'}
                    </button>
                </div>
            </div>
        </div>
    );
}

// ---------- Link Video Modal ----------
function LinkVideoModal({ isOpen, onClose, campaignId, deal, onLinked, existingVideos = [], source = 'deal' }) {
    const [videoInput, setVideoInput] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const extractVideoId = (input) => {
        const trimmed = input.trim();
        const urlMatch = trimmed.match(/(?:v=|youtu\.be\/|\/embed\/|\/shorts\/|\/live\/)([A-Za-z0-9_-]{11})/);
        return urlMatch ? urlMatch[1] : trimmed;
    };

    const isValidVideoId = (id) => /^[A-Za-z0-9_-]{11}$/.test(id);

    const handleVideoInputChange = (e) => {
        const raw = e.target.value;
        const extracted = extractVideoId(raw);
        setVideoInput(extracted);
        if (raw.trim() && !isValidVideoId(extracted)) {
            setError('Invalid YouTube video link or ID. Please enter a valid YouTube URL or 11-character video ID.');
        } else {
            setError('');
        }
    };

    const handleSubmit = async () => {
        const videoId = videoInput.trim();
        if (!videoId) { setError('Please enter a YouTube video ID or URL.'); return; }
        if (!isValidVideoId(videoId)) { setError('Invalid YouTube video link or ID. Please enter a valid YouTube URL or 11-character video ID.'); return; }
        // const alreadyLinked = existingVideos.some(v => v.youtubeVideoId === videoId || v.youtube_video_id === videoId || v.videoId === videoId);
        // if (alreadyLinked) { setError('This video is already linked.'); return; }
        setError('');
        setSaving(true);
        try {
            const video = await linkPlannerVideo(campaignId, deal.id, videoId);
            mixpanel.track(source === 'manual' ? 'campaign_video_manually_linked' : 'campaign_video_linked_deals', {
                campaign_id: campaignId,
                deal_id: deal?.id,
                video_id: videoId,
            });
            onLinked && onLinked(video);
            toast.success('Video linked successfully');
            onClose();
        } catch (e) {
            const message = e?.detail?.message || e.message || 'Failed to link video. Please try again.';
            setError(message);
            toast.error(message);
        } finally {
            setSaving(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 16 }} onClick={onClose}>
            <div style={{ background: '#fff', borderRadius: 20, width: '100%', maxWidth: 420 }} onClick={e => e.stopPropagation()}>
                <div style={{ padding: '20px 24px 14px', borderBottom: '1px solid #f3f4f6' }}>
                    <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#111827' }}>Link YouTube Video</h2>
                    <p style={{ margin: '4px 0 0', fontSize: 13, color: '#9ca3af' }}>Creator: <strong>{deal?.creatorName}</strong></p>
                </div>
                <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 14 }}>
                    <div>
                        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.4px' }}>YouTube Video ID or URL *</label>
                        <input
                            type="text"
                            placeholder="e.g. dQw4w9WgXcQ or full YouTube URL"
                            value={videoInput}
                            onChange={handleVideoInputChange}
                            style={{ width: '100%', padding: '10px 12px', border: `1px solid ${error ? '#f87171' : '#e5e7eb'}`, borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
                        />
                        {error
                            ? <p style={{ margin: '6px 0 0', fontSize: 12, color: '#dc2626' }}>{error}</p>
                            : <p style={{ margin: '6px 0 0', fontSize: 12, color: '#9ca3af' }}>Paste a YouTube URL or enter the 11-character video ID.</p>
                        }
                    </div>
                    <div style={{ padding: 12, background: '#fef2f2', borderRadius: 8, border: '1px solid #fecaca', fontSize: 12, color: '#b91c1c' }}>
                        <span style={{ fontWeight: 700 }}>Note:</span> If this creator has a YCP deal, a video collaboration will be created automatically once consent is granted.
                    </div>
                </div>
                <div style={{ padding: '14px 24px', borderTop: '1px solid #f3f4f6', display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                    <button onClick={onClose} disabled={saving} style={{ padding: '9px 18px', background: '#f9fafb', color: '#374151', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>Cancel</button>
                    <button onClick={handleSubmit} disabled={saving || !!error || !videoInput.trim()} style={{ padding: '9px 18px', background: '#dc2626', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: (saving || !!error || !videoInput.trim()) ? 'not-allowed' : 'pointer', opacity: (saving || !!error || !videoInput.trim()) ? 0.5 : 1 }}>
                        {saving ? 'Linking...' : '🔗 Link Video'}
                    </button>
                </div>
            </div>
        </div>
    );
}

function EditCampaignModal({ isOpen, onClose, campaign, campaignId, onSaved }) {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [form, setForm] = useState({
        name: '',
        objective: '',
        start_date: '',
        end_date: '',
    });

    useEffect(() => {
        if (!campaign || !isOpen) return;
        setForm({
            name: campaign.name || '',
            objective: campaign.objective || '',
            start_date: campaign.startDate || '',
            end_date: campaign.endDate || '',
        });
        setError('');
    }, [campaign, isOpen]);

    if (!isOpen || !campaign) return null;

    const set = (key, value) => setForm(prev => ({ ...prev, [key]: value }));

    const handleSave = async () => {
        if (!form.name.trim()) {
            setError('Campaign name is required.');
            return;
        }
        if (!form.start_date || !form.end_date) {
            setError('Start and end dates are required.');
            return;
        }
        if (new Date(form.end_date) < new Date(form.start_date)) {
            setError('End date must be on or after start date.');
            return;
        }

        setError('');
        setSaving(true);
        try {
            const updated = await updatePlannerCampaign(campaignId, {
                name: form.name.trim(),
                objective: form.objective.trim(),
                start_date: form.start_date,
                end_date: form.end_date,
            });
            mixpanel.track('campaign_edited', { campaign_id: campaignId, campaign_name: form.name });
            onSaved && onSaved(updated);
            toast.success('Campaign updated successfully');
            window.location.reload();
        } catch (e) {
            const message = e?.message || 'Failed to update campaign. Please try again.';
            setError(message);
            toast.error(message);
        } finally {
            setSaving(false);
        }
    };

    const inputStyle = {
        width: '100%',
        padding: '10px 12px',
        border: '1px solid #e5e7eb',
        borderRadius: 8,
        fontSize: 14,
        outline: 'none',
        boxSizing: 'border-box',
        fontFamily: 'inherit',
    };

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2200, padding: 16 }} onClick={onClose}>
            <div style={{ background: '#fff', borderRadius: 20, width: '100%', maxWidth: 500 }} onClick={e => e.stopPropagation()}>
                <div style={{ padding: '20px 24px 14px', borderBottom: '1px solid #f3f4f6' }}>
                    <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#111827' }}>Edit Campaign</h2>
                    <p style={{ margin: '4px 0 0', fontSize: 13, color: '#9ca3af' }}>Update details and extend campaign date range if needed.</p>
                </div>

                <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 14 }}>
                    {error && <div style={{ padding: '10px 14px', background: '#fee2e2', borderRadius: 8, fontSize: 13, color: '#991b1b' }}>{error}</div>}

                    <div>
                        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Campaign Name *</label>
                        <input type="text" value={form.name} onChange={e => set('name', e.target.value)} style={inputStyle} />
                    </div>

                    <div>
                        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Campaign Objective</label>
                        <textarea rows={2} value={form.objective} onChange={e => set('objective', e.target.value)} style={{ ...inputStyle, resize: 'vertical' }} />
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                        <div>
                            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Start Date *</label>
                            <input type="date" value={form.start_date} onChange={e => set('start_date', e.target.value)} style={inputStyle} />
                        </div>
                        <div>
                            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.4px' }}>End Date *</label>
                            <input type="date" value={form.end_date} onChange={e => set('end_date', e.target.value)} style={inputStyle} />
                        </div>
                    </div>


                </div>

                <div style={{ padding: '14px 24px', borderTop: '1px solid #f3f4f6', display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                    <button onClick={onClose} disabled={saving} style={{ padding: '9px 18px', background: '#f9fafb', color: '#374151', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>Cancel</button>
                    <button onClick={handleSave} disabled={saving} style={{ padding: '9px 18px', background: '#111827', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: saving ? 0.7 : 1 }}>
                        {saving ? 'Saving...' : 'Save Changes'}
                    </button>
                </div>
            </div>
        </div>
    );
}

// ---------- Deal normalizer (API → component shape) ----------
function normalizeDealItem(d) {
    if (!d) return d;
    const stripState = (s) => String(s || '').replace(/^STATE_/i, '').trim();

    // Already mapped by plannerCampaignApi (creatorName set) — keep workflow `status`, only sync BC lifecycle.
    if (d.creatorName !== undefined) {
        const bc = d.bc_response || d.bcResponse || d.bc || {};
        const bcLifecycle = stripState(
            d.bc_deal_state || pickBrandConnectField(bc, 'state', 'State'),
        );
        return {
            ...d,
            ...(bcLifecycle ? { dealStatus: bcLifecycle } : {}),
        };
    }
    const bc = d.bc_response || d.bcResponse || {};
    const cc = bc.creator_cost || bc.creatorCost;
    const cost = cc
        ? {
            amount: Number(
                pickBrandConnectField(cc, 'units', 'Units') ?? cc.units ?? 0,
            ),
            currency: pickBrandConnectField(cc, 'currency_code', 'currencyCode') || 'INR',
        }
        : (d.final_price != null ? { amount: d.final_price, currency: 'INR' } : undefined);
    const bcLifecycle = stripState(
        d.bc_deal_state || pickBrandConnectField(bc, 'state', 'State'),
    );
    return {
        id: d.id,
        creatorName: d.creator_name || d.channel_title || d.influencer_name || '',
        channelId: d.creator_channel_id || '',
        subscriberCount: d.subscriber_count ?? null,
        channelViewCount: d.channel_view_count ?? null,
        channelVideoCount: d.channel_video_count ?? null,
        thumbnailUrl: d.thumbnail_url || null,
        // Workflow vs BC deal lifecycle (same split as mapDealFromApi)
        status: d.status != null ? String(d.status).trim().toLowerCase() : 'active',
        dealStatus: bcLifecycle || undefined,
        expectedVideos: pickBrandConnectField(bc, 'expected_video_count', 'expectedVideoCount')
            ?? d.expected_video_count
            ?? 1,
        deliveredVideos: d.video_count ?? 0,
        bcConsent: null,
        cost,
        partnershipTerms:
            pickBrandConnectField(bc, 'partnership_terms', 'partnershipTerms')
            || d.partnership_terms
            || '',
        createdAt: d.created_at || new Date().toISOString(),
    };
}

// ---------- Main Dashboard ----------
export default function HybridCampaignDashboard() {
    const { campaignId } = useParams();
    const history = useHistory();
    const [activeTab, setActiveTab] = useState('overview');
    const [showCreateDeal, setShowCreateDeal] = useState(false);
    const [showEditCampaign, setShowEditCampaign] = useState(false);
    const [linkVideoDeal, setLinkVideoDeal] = useState(null);
    const [linkVideoSource, setLinkVideoSource] = useState('deal');
    const [copied, setCopied] = useState(false);
    const [actionLoading, setActionLoading] = useState('');
    const [unlinkingVideoId, setUnlinkingVideoId] = useState(null);
    const [syncingAll, setSyncingAll] = useState(false);
    const [showCompleteConfirm, setShowCompleteConfirm] = useState(false);
    const [campaign, setCampaign] = useState(null);
    const [deals, setDeals] = useState([]);
    const [videos, setVideos] = useState([]);
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [overviewInsightVideo, setOverviewInsightVideo] = useState(null);
    const [editInsightsVideo, setEditInsightsVideo] = useState(null);

    const fetchCampaign = useCallback(() => {
        setLoading(true);
        setError(null);
        Promise.allSettled([
            getPlannerCampaignById(campaignId),
            getPlannerCampaignDeals(campaignId),
            getPlannerCampaignVideos(campaignId),
            getPlannerCampaignReport(campaignId),
        ])
            .then(([campaignResult, dealsResult, videosResult, reportResult]) => {
                const campaignData = campaignResult.status === 'fulfilled' ? campaignResult.value : null;
                if (!campaignData) { setError('Campaign not found.'); return; }

                const dealsData = dealsResult.status === 'fulfilled' ? dealsResult.value : null;
                const videosData = videosResult.status === 'fulfilled' ? videosResult.value : null;
                setCampaign(campaignData);
                setDeals((dealsData?.deals || campaignData.deals || []).map(normalizeDealItem));
                setVideos(videosData?.items || campaignData.videos || []);

                if (reportResult.status === 'fulfilled') {
                    setReportData(reportResult.value || null);
                } else {
                    setReportData(null);
                }
            })
            .catch(() => setError('Failed to load campaign. Please try again.'))
            .finally(() => setLoading(false));
    }, [campaignId]);

    useEffect(() => { fetchCampaign(); }, [fetchCampaign]);

    if (loading) return (
        <div style={{ padding: 40, textAlign: 'center' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>⏳</div>
            <div style={{ color: '#9ca3af', fontSize: 14 }}>Loading campaign...</div>
        </div>
    );

    if (error || !campaign) return (
        <div style={{ padding: 40, textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
            <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 8, color: '#991b1b' }}>{error || 'Campaign not found'}</div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
                <button onClick={fetchCampaign} style={{ padding: '10px 20px', background: '#dc2626', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Retry</button>
                <button onClick={() => history.push('/brandconnect/campaign')} style={{ padding: '10px 20px', background: '#111827', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>← Back to Campaigns</button>
            </div>
        </div>
    );

    const { bcData, bcEnabled, bcCampaignCode } = campaign;
    const sc = STATUS_COLORS[campaign.status] || STATUS_COLORS.draft;
    const linkedVideosFromList = videos.filter(v => v.consentStatus === 'ACTIVE').length;
    const derivedTotalViews = videos.reduce((sum, v) => sum + safeN(v.metrics?.views), 0);
    const derivedOrganicViews = videos.reduce((sum, v) => sum + safeN(v.trafficSplit?.organicViews), 0);
    const derivedPaidViews = videos.reduce((sum, v) => sum + safeN(v.trafficSplit?.paidViews), 0);

    const platformExpectedVideos = Object.values(campaign.platforms || {}).reduce(
        (sum, cfg) => sum + safeN(cfg?.expectedVideos),
        0,
    );
    const dealsExpectedVideos = deals.reduce((sum, d) => sum + safeN(d.expectedVideos), 0);

    const totalViews = safeN(firstN(bcData?.totalViews, bcData?.views, derivedTotalViews));
    const organicViewsValue = firstN(bcData?.organicViews, derivedOrganicViews) || 0;
    const paidViewsValue = firstN(
        bcData?.paidViews,
        derivedPaidViews,
        totalViews > 0 && organicViewsValue != null ? totalViews - organicViewsValue : null,
    ) || 0;

    const organicPct = organicViewsValue ? Math.round((organicViewsValue || 0) / (organicViewsValue + paidViewsValue) * 100) : 0;
    const paidPct = paidViewsValue ? Math.round((paidViewsValue || 0) / (organicViewsValue + paidViewsValue) * 100) : 0;
    // const organicPct = bcData
    //     ? (bcData.organicPercent != null
    //         ? safeN(bcData.organicPercent)
    //         : (organicViewsValue != null && totalViews > 0
    //             ? Math.round((safeN(organicViewsValue) / totalViews) * 100)
    //             : null))
    //     : null;
    const organicReachValue = organicViewsValue != null ? fmtN(organicViewsValue) : '-';

    // const paidPct = organicPct != null ? Math.max(0, 100 - organicPct) : null;
    const videosLinked = bcData?.videosLinked != null ? safeN(bcData.videosLinked) : linkedVideosFromList;
    const videosTotal = bcData?.videosTotal != null
        ? safeN(bcData.videosTotal)
        : firstN(platformExpectedVideos > 0 ? platformExpectedVideos : null, dealsExpectedVideos > 0 ? dealsExpectedVideos : null);
    const liveVideos = bcData?.liveVideos != null ? safeN(bcData.liveVideos) : linkedVideosFromList;
    const totalLikes = firstN(bcData?.totalLikes, videos.reduce((sum, v) => sum + safeN(v.metrics?.likes), 0));
    const totalComments = firstN(bcData?.totalComments, videos.reduce((sum, v) => sum + safeN(v.metrics?.comments), 0));

    const handleCopy = () => {
        navigator.clipboard.writeText(bcCampaignCode);
        setCopied(true);
        mixpanel.track('campaign_code_copied', { campaign_id: campaignId, campaign_code: bcCampaignCode });
        setTimeout(() => setCopied(false), 2000);
    };

    const TABS = [
        { id: 'overview', label: 'Overview', bc: true },
        { id: 'deals', label: 'Deals' },
        { id: 'videos', label: 'Videos', bc: true },
        { id: 'reports', label: 'Reports', bc: true },
    ];

    const handleRequestVideoLink = () => {
        if (!canMutateCampaign) {
            toast.error('Campaign must be ACTIVE to link videos.');
            return;
        }
        const targetDeal = deals.find(d => d.status === 'ACTIVE') || deals[0] || null;
        if (!targetDeal) return;
        setLinkVideoSource('manual');
        setLinkVideoDeal(targetDeal);
    };

    const normalizedStatus = String(campaign.status || '').toLowerCase();
    const isCompleted = ['completed', 'state_completed', 'complete'].includes(normalizedStatus);
    const isArchived = ['archived', 'state_archived', 'archive'].includes(normalizedStatus);
    const canMutateCampaign = !isCompleted && !isArchived;

    const handleCompleteCampaign = async () => {
        if (!canMutateCampaign) {
            toast.error('Campaign must be ACTIVE to complete.');
            return;
        }
        if (!allDealsFinal) {
            toast.error('Cannot complete campaign until all deals are COMPLETED or CANCELED.');
            return;
        }
        setShowCompleteConfirm(false);
        setActionLoading('complete');
        try {
            await completePlannerCampaign(campaignId);
            mixpanel.track('campaign_completed', { campaign_id: campaignId, campaign_name: campaign.name });
            toast.success('Campaign marked as complete');
            fetchCampaign();
        } catch (e) {
            toast.error(e?.message || 'Failed to complete campaign');
        } finally {
            setActionLoading('');
        }
    };

    const handleMarkCompleteDeal = async (deal) => {
        if (!canMutateCampaign) {
            toast.error('Campaign must be ACTIVE to modify deals.');
            return;
        }
        try {
            await completePlannerDeal(campaignId, deal.id);
            setDeals(prev => prev.map(d => (d.id === deal.id ? { ...d, dealStatus: 'COMPLETED' } : d)));
            toast.success(`Deal with ${deal.creatorName} marked complete`);
        } catch (e) {
            toast.error(e?.message || 'Failed to complete deal');
        }
    };

    const handleActivateDeal = async (deal) => {
        if (!canMutateCampaign) {
            toast.error('Campaign must be ACTIVE to modify deals.');
            return;
        }
        try {
            await activatePlannerDeal(campaignId, deal.id);
            setDeals(prev => prev.map(d => (d.id === deal.id ? { ...d, dealStatus: 'ACTIVE' } : d)));
            toast.success(`Deal with ${deal.creatorName} reactivated`);
        } catch (e) {
            toast.error(e?.message || 'Failed to reactivate deal');
        }
    };

    const handleArchiveCampaign = async () => {
        if (!canMutateCampaign) {
            toast.error('Campaign must be ACTIVE to archive.');
            return;
        }
        if (!allDealsFinal) {
            toast.error('Cannot archive campaign until all deals are COMPLETED or CANCELED.');
            return;
        }
        if (!window.confirm('Archive this campaign? You can no longer run active collaboration actions after archiving.')) return;
        setActionLoading('archive');
        try {
            await archivePlannerCampaign(campaignId);
            mixpanel.track('campaign_archived', { campaign_id: campaignId, campaign_name: campaign.name });
            toast.success('Campaign archived successfully');
            history.push('/brandconnect/campaign');
        } catch (e) {
            toast.error(e?.message || 'Failed to archive campaign');
        } finally {
            setActionLoading('');
        }
    };

    const handleUnlinkVideo = async (video) => {
        const videoId = video?.youtubeVideoId || video?.id;
        if (!videoId) {
            toast.error('Unable to unlink this video because video id is missing.');
            return;
        }
        setUnlinkingVideoId(video.id);
        try {
            await unlinkPlannerVideo(campaignId, videoId);
            setVideos(prev => prev.filter(v => v.id !== video.id));
            toast.success('Video collaboration unlinked');
        } catch (e) {
            toast.error(e?.message || 'Failed to unlink video collaboration');
        } finally {
            setUnlinkingVideoId(null);
        }
    };

    const handleCancelDeal = async (deal) => {
        if (!canMutateCampaign) {
            toast.error('Campaign must be ACTIVE to modify deals.');
            return;
        }
        try {
            await cancelPlannerCreatorDeal(campaignId, deal.id);
            setDeals(prev => prev.map(d => (d.id === deal.id
                ? { ...d, dealStatus: 'CANCELED', bc_deal_state: 'STATE_CANCELED' }
                : d)));
            toast.success(`Deal with ${deal.creatorName} cancelled`);
        } catch (e) {
            toast.error(e?.message || 'Failed to cancel deal');
        }
    };

    const handleSyncAll = async () => {
        const syncable = videos.filter(v => v.youtubeVideoId);
        if (syncable.length === 0) {
            toast.error('No videos with a YouTube ID to sync.');
            return;
        }
        setSyncingAll(true);
        const results = await Promise.allSettled(
            syncable.map(v => syncPlannerVideo(v.youtubeVideoId))
        );
        const failed = results.filter(r => r.status === 'rejected').length;
        if (failed === 0) {
            toast.success(`All ${syncable.length} video${syncable.length > 1 ? 's' : ''} synced successfully`);
        } else {
            toast.error(`${failed} of ${syncable.length} videos failed to sync`);
        }
        setSyncingAll(false);
        fetchCampaign();
    };

    const isDealCompleted = (deal) => {
        const state = String(deal.dealStatus || deal.status || '');
        const normalized = state.replace(/^STATE_/, '').toUpperCase();
        return normalized === 'COMPLETE' || normalized === 'COMPLETED';
    };

    const isDealCanceled = (deal) => {
        const state = String(deal.dealStatus || deal.status || '');
        const normalized = state.replace(/^STATE_/, '').toUpperCase();
        return normalized === 'CANCELED' || normalized === 'CANCELLED';
    };

    // "Final" means deal is no longer ACTIVE (COMPLETED or CANCELED).
    const isDealFinal = (deal) => isDealCompleted(deal) || isDealCanceled(deal);

    // Per BrandConnect rules: campaign can only be completed/archived when ALL deals are final.
    // With no deals, this is vacuously true.
    const allDealsFinal = deals.every(isDealFinal);
    const isCompleteDisabled =
        actionLoading === 'complete' ||
        actionLoading === 'archive' ||
        !canMutateCampaign ||
        !allDealsFinal;
    
    const isArchiveDisabled =
        actionLoading === 'archive' ||
        actionLoading === 'complete' ||
        !canMutateCampaign ||
        !allDealsFinal;
    
    return (
        <div style={{ width: '100%', padding: '24px 32px', boxSizing: 'border-box' }}>
            {/* Breadcrumb */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#9ca3af', marginBottom: 20 }}>
                <Link to="/brandconnect/campaign" style={{ color: '#9ca3af', textDecoration: 'none' }}>My Campaigns</Link>
                <span>/</span>
                <span style={{ color: '#374151', fontWeight: 500 }}>{campaign.name}</span>
            </div>

            {/* Campaign Header */}
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
                    <div style={{ width: 52, height: 52, borderRadius: 14, background: bcEnabled ? 'linear-gradient(135deg,#ef4444,#dc2626)' : 'linear-gradient(135deg,#fbbf24,#f59e0b)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, flexShrink: 0 }}>
                        {bcEnabled ? '🎬' : '📢'}
                    </div>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                            <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#111827' }}>{campaign.name}</h1>
                            {bcEnabled && <span style={{ padding: '2px 8px', background: '#dc2626', color: '#fff', fontSize: 11, fontWeight: 700, borderRadius: 4 }}>YCP</span>}
                            <span style={{ padding: '3px 10px', background: sc.bg, color: sc.color, fontSize: 11, fontWeight: 700, borderRadius: 20, textTransform: 'capitalize' }}>{campaign.status}</span>
                        </div>
                        <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: 14 }}>{campaign.objective}</p>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                    <div style={{ fontSize: 13, color: '#6b7280', fontWeight: 500, paddingTop: 4 }}>{campaign.startDate} - {campaign.endDate}</div>
                    <button
                        onClick={() => setShowEditCampaign(true)}
                        disabled={!canMutateCampaign}
                        title={canMutateCampaign ? 'Edit campaign' : 'Campaign is terminal (COMPLETED/ARCHIVED) and cannot be edited'}
                        style={{
                            padding: '8px 12px',
                            background: '#f3f4f6',
                            color: '#374151',
                            border: '1px solid #e5e7eb',
                            borderRadius: 8,
                            fontSize: 12,
                            fontWeight: 600,
                            cursor: canMutateCampaign ? 'pointer' : 'not-allowed',
                            opacity: canMutateCampaign ? 1 : 0.6,
                        }}
                    >
                        Edit Campaign
                    </button>
                    {canMutateCampaign && (
                        <button
                            onClick={() => setShowCompleteConfirm(true)}
                            disabled={isCompleteDisabled}
                            title={!allDealsFinal ? 'All deals must be COMPLETED or CANCELED before completing the campaign.' : 'Complete this campaign'}
                            style={{
                                padding: '8px 12px',
                                background: isCompleteDisabled ? '#86efac' : '#16a34a',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 8,
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: isCompleteDisabled ? 'not-allowed' : 'pointer',
                                opacity: isCompleteDisabled ? 0.7 : 1
                            }}
                        >
                            {actionLoading === 'complete' ? 'Completing...' : 'Complete Campaign'}
                        </button>
                    )}
                    {canMutateCampaign && (
                        <button
                            onClick={handleArchiveCampaign}
                            disabled={isArchiveDisabled}
                            title={!allDealsFinal ? 'All deals must be COMPLETED or CANCELED before archiving the campaign.' : 'Archive this campaign'}
                            style={{
                                padding: '8px 12px',
                                background: isArchiveDisabled ? '#fca5a5' : '#fff',
                                color: '#b91c1c',
                                border: '1px solid #fecaca',
                                borderRadius: 8,
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: isArchiveDisabled ? 'not-allowed' : 'pointer',
                                opacity: isArchiveDisabled ? 0.7 : 1
                            }}
                        >
                            {actionLoading === 'archive' ? 'Archiving...' : 'Archive Campaign'}
                        </button>
                    )}
                </div>
            </div>

            {/* Statistics Row */}
            {bcEnabled && bcData && (
                <div style={{ background: '#fff', border: '1px solid #f3f4f6', borderRadius: 14, padding: '18px 24px', marginBottom: 16 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ color: '#dc2626', fontSize: 14 }}>▶</span>
                            <span style={{ fontWeight: 600, fontSize: 14 }}>Statistics</span>
                            <span style={{ padding: '2px 8px', background: '#dc2626', color: '#fff', fontSize: 10, fontWeight: 700, borderRadius: 4 }}>YCP Verified</span>
                        </div>
                        <span style={{ fontSize: 12, color: '#9ca3af' }}>YouTube Analytics</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', gap: 8 }}>
                        {[
                            { icon: '👁', value: fmtN(totalViews), label: 'Total Views' },
                            { icon: '👍', value: fmtN(totalLikes), label: 'Total Likes' },
                            { icon: '💬', value: String(safeN(totalComments)), label: 'Total Comments' },
                            { icon: '🎬', value: String(safeN(liveVideos)), label: 'Live Videos' },
                            { icon: '🌱', value: organicReachValue, label: 'Organic Reach', green: true },
                        ].map(s => (
                            <div key={s.label} style={{ textAlign: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginBottom: 2 }}>
                                    <span style={{ fontSize: 18 }}>{s.icon}</span>
                                    <span style={{ fontSize: 24, fontWeight: 700, color: s.green ? '#16a34a' : '#111827' }}>{s.value}</span>
                                </div>
                                <div style={{ fontSize: 11, color: '#9ca3af' }}>{s.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* BC Insights Panel */}
            {bcEnabled && bcData && (
                <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 14, padding: '16px 24px', marginBottom: 20 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
                        <span style={{ padding: '2px 8px', background: '#dc2626', color: '#fff', fontSize: 11, fontWeight: 700, borderRadius: 4 }}>YCP</span>
                            <span style={{ fontWeight: 700, fontSize: 15 }}>Creator Partnerships Insights</span>
                        <span style={{ marginLeft: 'auto', fontSize: 12, color: '#9ca3af' }}>Verified YouTube Data</span>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'auto 180px 1fr', gap: 24, alignItems: 'start' }}>
                        {/* Campaign Code */}
                        {bcCampaignCode && (
                            <div>
                                <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 6 }}>Campaign Code</div>
                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '8px 14px', background: '#fff', border: '2px solid #fca5a5', borderRadius: 10 }}>
                                    <span style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 22, color: '#dc2626', letterSpacing: 3 }}>{bcCampaignCode}</span>
                                    <button onClick={handleCopy} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 16 }} title="Copy">{copied ? '✓' : '📋'}</button>
                                </div>
                                <p style={{ margin: '8px 0 0', fontSize: 12, color: '#b91c1c', maxWidth: 320 }}>
                                    Share this code with the creator so they can connect the correct Creator Partnerships collaboration to this campaign.
                                </p>
                            </div>
                        )}
                        {/* Videos Linked */}
                        <div>
                            <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 6 }}>Videos Linked</div>
                            <div style={{ fontSize: 26, fontWeight: 700, color: '#111827' }}>
                                {videosLinked != null ? videosLinked : '-'}/{videosTotal != null ? videosTotal : '-'}
                            </div>
                            <div style={{ marginTop: 8, height: 6, background: '#fecaca', borderRadius: 3, overflow: 'hidden' }}>
                                <div style={{ width: videosLinked != null && videosTotal > 0 ? `${(videosLinked / videosTotal) * 100}%` : '0%', height: '100%', background: '#dc2626', borderRadius: 3, transition: 'width 0.4s' }} />
                            </div>
                        </div>
                        {/* Traffic Breakdown */}
                        <div>
                            <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 6 }}>Traffic Source Breakdown</div>
                            <div style={{ display: 'flex', height: 30, borderRadius: 6, overflow: 'hidden', marginBottom: 6 }}>
                                <div style={{ width: `${organicPct != null ? organicPct : 0}%`, background: '#22c55e', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 12, fontWeight: 700 }}>
                                    {organicViewsValue != null && organicPct > 15 && `${organicPct}%`}
                                </div>
                                <div style={{ width: `${paidPct != null ? paidPct : 0}%`, background: '#6366f1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 12, fontWeight: 700 }}>
                                    {paidViewsValue != null && paidPct > 15 && `${paidPct}%`}
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
                                <span style={{ color: '#16a34a' }}>Organic: {organicViewsValue != null ? fmtN(organicViewsValue) : '-'}</span>
                                <span style={{ color: '#4f46e5' }}>Paid: {paidViewsValue != null ? fmtN(paidViewsValue) : '-'}</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Tabs */}
            <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #f3f4f6', overflow: 'hidden' }}>
                <div style={{ display: 'flex', borderBottom: '1px solid #f3f4f6', padding: '0 24px' }}>
                    {TABS.map(tab => (
                        <button key={tab.id} onClick={() => setActiveTab(tab.id)} style={{
                            display: 'flex', alignItems: 'center', gap: 6, padding: '14px 16px', fontSize: 13, fontWeight: 500,
                            background: 'none', border: 'none', cursor: 'pointer', marginBottom: -1,
                            borderBottom: `2px solid ${activeTab === tab.id ? (tab.bc ? '#dc2626' : '#f59e0b') : 'transparent'}`,
                            color: activeTab === tab.id ? (tab.bc ? '#dc2626' : '#b45309') : '#6b7280',
                        }}>
                            {tab.label}
                            {tab.bc && <span style={{ padding: '1px 5px', background: '#dc2626', color: '#fff', fontSize: 9, fontWeight: 700, borderRadius: 3 }}>YCP</span>}
                        </button>
                    ))}
                </div>

                <div style={{ padding: 24 }}>
                    {/* Overview Tab */}
                    {activeTab === 'overview' && (
                        <div>
                            <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 4 }}>Video Performance</div>
                            <div style={{ fontSize: 13, color: '#9ca3af', marginBottom: 16 }}>Individual video metrics from YouTube Creator Partnerships</div>
                            {videos.length === 0 ? (
                                <div style={{ textAlign: 'center', padding: 40, background: '#f9fafb', borderRadius: 12 }}>
                                    <div style={{ fontSize: 36, marginBottom: 8 }}>🎬</div>
                                    <div style={{ fontWeight: 600 }}>No videos yet</div>
                                    <p style={{ color: '#6b7280', fontSize: 13 }}>Link videos to see performance metrics here</p>
                                </div>
                            ) : (
                                <div style={{ background: '#fff', border: '1px solid #f3f4f6', borderRadius: 12, overflow: 'hidden' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                                        <thead>
                                            <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                                                {['Video', 'Creator', 'Views', 'Organic %', 'Engagement', ''].map((h, i) => (
                                                    <th key={h || 'actions'} style={{ padding: '10px 12px', fontWeight: 700, color: '#6b7280', textAlign: i < 2 ? 'left' : (i === 5 ? 'center' : 'right'), fontSize: 12 }}>{h}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {videos.map(v => {
                                                const vViews = safeN(v.metrics?.views);
                                                const organicPct = v.trafficSplit?.organic != null ? Math.round(safeN(v.trafficSplit.organic)) : (vViews > 0 && v.trafficSplit?.organicViews != null ? Math.round((safeN(v.trafficSplit.organicViews) / vViews) * 100) : 100);
                                                const engagement = safeN(v.metrics?.likes) + safeN(v.metrics?.comments);
                                                return (
                                                    <tr key={v.id} style={{ borderBottom: '1px solid #f9fafb' }}>
                                                        <td style={{ padding: '10px 12px', fontWeight: 600, color: '#111827', maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.title || '—'}</td>
                                                        <td style={{ padding: '10px 12px', color: '#6b7280' }}>{v.creatorName || '—'}</td>
                                                        <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600 }}>{fmtN(vViews)}</td>
                                                        <td style={{ padding: '10px 12px', textAlign: 'right' }}>
                                                            <span style={{ color: '#16a34a', fontWeight: 700 }}>{organicPct}%</span>
                                                        </td>
                                                        <td style={{ padding: '10px 12px', textAlign: 'right', color: '#374151' }}>{fmtN(engagement)}</td>
                                                        <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                                                            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                                                <button
                                                                    onClick={() => setOverviewInsightVideo(v)}
                                                                    style={{ padding: '4px 12px', background: '#eef2ff', color: '#4f46e5', border: '1px solid #c7d2fe', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
                                                                >
                                                                    Insights
                                                                </button>
                                                                {FEATURE_YT_ADSTATS && v.consentStatus === 'ACTIVE' && (
                                                                    <button
                                                                        onClick={() => setEditInsightsVideo(v)}
                                                                        style={{ padding: '4px 12px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
                                                                    >
                                                                        Edit insights
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                            {overviewInsightVideo && (
                                <VideoInsightsModal video={overviewInsightVideo} onClose={() => setOverviewInsightVideo(null)} />
                            )}
                            {editInsightsVideo && (
                                <EditVideoInsightsModal
                                    isOpen
                                    video={editInsightsVideo}
                                    campaignId={campaignId}
                                    onClose={() => setEditInsightsVideo(null)}
                                    onSaved={() => fetchCampaign()}
                                />
                            )}
                        </div>
                    )}

                    {/* Deals Tab */}
                    {activeTab === 'deals' && (
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                                <div>
                                    <div style={{ fontWeight: 700, fontSize: 16 }}>Creator Deals</div>
                                    <div style={{ fontSize: 13, color: '#9ca3af', marginTop: 2 }}>{deals.length} deals in this campaign</div>
                                </div>
                                <button
                                    onClick={() => setShowCreateDeal(true)}
                                    disabled={!canMutateCampaign}
                                    title={canMutateCampaign ? 'Add a new creator deal' : 'Campaign must be ACTIVE to create/modify deals'}
                                    style={{
                                        padding: '9px 18px',
                                        background: '#dc2626',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: 8,
                                        fontSize: 13,
                                        fontWeight: 600,
                                        cursor: canMutateCampaign ? 'pointer' : 'not-allowed',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        opacity: canMutateCampaign ? 1 : 0.55,
                                    }}
                                >
                                    + Add Creator
                                </button>
                                {/* Shortlist Creator Modal */}
                                <ShortlistCreatorModal
                                    isOpen={showCreateDeal}
                                    onClose={() => setShowCreateDeal(false)}
                                    campaignId={campaignId}
                                    bcEnabled={campaign.bcEnabled}
                                    onCreated={(deal) => setDeals(prev => [...prev, deal])}
                                />
                            </div>
                            {deals.length === 0 ? (
                                <div style={{ textAlign: 'center', padding: 40, background: '#f9fafb', borderRadius: 12, marginTop: 12 }}>
                                    <div style={{ fontSize: 36, marginBottom: 8 }}>🤝</div>
                                    <div style={{ fontWeight: 600 }}>No deals yet</div>
                                    <p style={{ color: '#6b7280', fontSize: 13 }}>Add your first creator deal to get started</p>
                                </div>
                            ) : (
                                <div style={{ border: '1px solid #f3f4f6', borderRadius: 12, overflow: 'hidden', marginTop: 12 }}>
                                    {/* Table header */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '10px 24px', background: '#f9fafb', borderBottom: '1px solid #f3f4f6' }}>
                                        <div style={{ flex: 1, fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase' }}>Creator</div>
                                        <div style={{ width: 90, fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', textAlign: 'center' }}>Status</div>
                                        <div style={{ width: 90, fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', textAlign: 'center' }}>Deal Status</div>
                                        <div style={{ width: 90, fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', textAlign: 'center' }}>Videos</div>
                                        {bcEnabled && <div style={{ width: 80, fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', textAlign: 'center' }}>Consent</div>}
                                        <div style={{ width: 160, fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase' }}>Partnership Terms</div>
                                        <div style={{ width: 70, fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', textAlign: 'right' }}>Cost</div>
                                        <div style={{ width: 60 }} />
                                    </div>
                                    {deals.map(d => (
                                        <DealRow
                                            key={d.id}
                                            deal={d}
                                            bcEnabled={bcEnabled}
                                            canMutateCampaign={canMutateCampaign}
                                            onLinkVideo={() => { setLinkVideoSource('deal'); setLinkVideoDeal(d); }}
                                            onCancelDeal={handleCancelDeal}
                                            onMarkComplete={handleMarkCompleteDeal}
                                            onActivateDeal={handleActivateDeal}
                                        />
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                    {activeTab === 'videos' && (
                        <VideosTab
                            campaign={campaign}
                            campaignId={campaignId}
                            videos={videos}
                            onRequestVideoLink={handleRequestVideoLink}
                            canRequestVideoLink={deals.length > 0}
                            onUnlinkVideo={handleUnlinkVideo}
                            unlinkingVideoId={unlinkingVideoId}
                            onSyncAll={handleSyncAll}
                            syncingAll={syncingAll}
                            onInsightsSaved={() => fetchCampaign()}
                        />
                    )}

                    {activeTab === 'reports' && (
                        <ReportsTab campaign={campaign} deals={deals} videos={videos} reportData={reportData} />
                    )}
                </div>
            </div>

            {/* Link Video Modal */}
            {linkVideoDeal && (
                <LinkVideoModal
                    isOpen={Boolean(linkVideoDeal)}
                    onClose={() => setLinkVideoDeal(null)}
                    campaignId={campaignId}
                    deal={linkVideoDeal}
                    existingVideos={videos}
                    source={linkVideoSource}
                    onLinked={(video) => {
                        setVideos(prev => [...prev, video]);
                        setLinkVideoDeal(null);
                    }}
                />
            )}

            {/* Complete Campaign Confirm */}
            <ConfirmModal
                isOpen={showCompleteConfirm}
                title="Complete this campaign?"
                message="This will mark the campaign as complete and close active lifecycle actions. This cannot be undone."
                confirmLabel="Complete Campaign"
                loading={actionLoading === 'complete'}
                onConfirm={handleCompleteCampaign}
                onClose={() => setShowCompleteConfirm(false)}
            />

            <EditCampaignModal
                isOpen={showEditCampaign}
                onClose={() => setShowEditCampaign(false)}
                campaign={campaign}
                campaignId={campaignId}
                onSaved={(updatedCampaign) => {
                    if (!updatedCampaign) {
                        fetchCampaign();
                        return;
                    }
                    setCampaign(prev => ({ ...prev, ...updatedCampaign }));
                }}
            />
        </div>
    );
}
